<script setup>
import { ref, reactive, onBeforeMount, onMounted, nextTick } from "vue";
import YTCard from "@/components/YTCard/YTCard.vue";
import YTAddress from "@/components/YTAddress/newIndex.vue";
import YTCheckTag from "@/components/YTCheckTag/replaceMode.vue";
import YTEditor from "@/components/YTEditor/index.vue";
import BoxUpload from "@/components/YTBoxUpload/newIndex.vue";
import { getRoute } from "@/hooks/getRoute.js";
import {
  listClubCategory,
} from "@/api/club/club.js";
import moment from "moment/moment.js";
import router from "@/router/index.js";
const { route } = getRoute();
import YTRadio from "@/components/YTRadio/index.vue";
import YTTagSelect from "@/components/YTTagSelect/index.vue";
import {tagGroupsListByUsageScenario} from "@/api/tagGroup/tagGroup.js";
import {formatTags} from "@/hooks/tag.js";
import YTGender from "@/components/YTGender/index.vue";
import {
  getStoreMemberListWithTagAdmin,
  getStoreMemberTotalAdmin,
  listStoreMemberTagChecked
} from "@/api/storeMember/storeMember.js";
import {disabledEndDate} from "@/hooks/dateUtils.js";
import YTI18NTabs from "@/components/YTIN18Tabs/index.vue";
import {listTenantOrganizeIgnore} from "@/api/tenant/tenant.js";
import {certificateTypeEnum} from "@/enum/certificateTypeEnum.js";
import {itemDetail} from "@/api/goods/goods.js";
import {itemListIgnore} from "@/api/goods/ignireTenant.js";
import YTCheckPanel from "@/components/YTCheckedPanel/index.vue";
import {listInsurance} from "@/api/insurance/insurance.js";
import {insuranceDurationUnitEnum} from "@/enum/insuranceDurationUnitEnum.js";
import {addTreasureActivity, detailTreasureActivity} from "@/api/treasureActivity/treasureActivity.js";

const requirementFields = [
  "emergencyContactRequirement",
  "emergencyContactPhoneRequirement",
  "shippingInfoRequirement",
  "remarkRequirement",
  "certificateRequirement",
  "genderRequirement",
  "birthdayRequirement",
];

const normalizeRequirementFormValue = (value, defaultValue = ["REQUIRED"]) => {
  if (Array.isArray(value)) return value;
  if (value === null || value === undefined || value === "") return defaultValue;
  return [value];
};

const normalizeMultipleValue = (value) => {
  if (Array.isArray(value)) return value;
  if (value === null || value === undefined || value === "") return [];
  return String(value).split(",").filter(Boolean);
};

const formatRequirementSubmitValue = (value) => {
  if (Array.isArray(value)) return value[0] ?? null;
  return value ?? null;
};

/*初次加载*/
onBeforeMount(async () => {
  await handleGetActivityTagsList('init');
  await handleGetStoreGroups();
  await handleGetInsuranceList();
  isEdit.value = Boolean(route.query.goodsId)
  if (isEdit.value) {
    await getDetail(route.query.goodsId)
  } else {
    loading.value = false
  }
  handleResetActivityContainerScrollTop()
});

onMounted(() => {
  handleResetActivityContainerScrollTop()
})

// 处理进入页面时表单滚动容器置顶
const handleResetActivityContainerScrollTop = () => {
  nextTick(() => {
    const activityContainer = document.getElementById("activityContainer")
    if (activityContainer) activityContainer.scrollTop = 0
  })
}

// 是否为修改模式
const isEdit = ref(false);
// 获取活动详情信息
const getDetail = async (goodsId) => {
  try {
    loading.value = true;
    const res = await detailTreasureActivity(goodsId);
    ruleForm.queryType = res.tenantId === '101' ? 'BIKING_UP' : 'NOT_BIKING_UP'
    let organizeTypeRes = null
    switch (Number(res.organizeType)) {
      case 1:
        organizeTypeRes = "STORE"
        break
      case 3:
        organizeTypeRes = "CLUB"
        break
      case 4:
        organizeTypeRes = "VENUE"
        break
      case 5:
        organizeTypeRes = "BIKE_STORE"
        break
      case 6:
        organizeTypeRes = "THERAPIST_STORE"
        break
      case 7:
        organizeTypeRes = "PHOTOGRAPHY_STORE"
        break
      default:
        organizeTypeRes = "UNKOWN"
        break
    }
    ruleForm.type = organizeTypeRes
    ruleForm.storeId = res.storeId
    ruleForm.storeName = res.storeName
    ruleForm.images = res.images
    boxUploadRef.value.handleReview(ruleForm.images);
    ruleForm.discoverCoverImage = res.discoverCoverImage;
    if (ruleForm.discoverCoverImage) boxUploadDiscoverCoverRef.value.handleReview([ruleForm.discoverCoverImage]);
    ruleForm.goodsId = res.goodsId;
    ruleForm.goodsName = res.goodsName;
    ruleForm.goodsNameEn = res.goodsNameEn;
    ruleForm.addressCode = [
      res.treasureActivityInfo.provinceCode,
      res.treasureActivityInfo.cityCode,
    ];
    if (res.treasureActivityInfo.districtCode)
      ruleForm.addressCode.push(res.treasureActivityInfo.districtCode);
    ruleForm.treasureActivityInfo.provinceCode = res.treasureActivityInfo.provinceCode;
    ruleForm.treasureActivityInfo.cityCode = res.treasureActivityInfo.cityCode;
    ruleForm.treasureActivityInfo.districtCode = res.treasureActivityInfo.districtCode;
    ruleForm.addressDetail = res.treasureActivityInfo.addressDetail;
    ruleForm.addressDetailEn = res.treasureActivityInfo.addressDetailEn;
    ruleForm.storeGroup = res.storeGroup;
    ruleForm.tagList = res.tagList;
    nextTick(() => {
      // 处理活动分组反显
      YTCheckTagRef.value.handleReview([ruleForm.storeGroup]);
      // 处理活动标签反显
      YTTagSelectRef.value.handleYTCheckTagMultipleReview(ruleForm.tagList)
    });
    ruleForm.description = res.description;
    ruleForm.descriptionEn = res.descriptionEn;
    ruleForm.inventory = res.inventory ? res.inventory : { totalQty: 1 };
    ruleForm.retailPrice = res.retailPrice;
    ruleForm.treasureActivityInfo.refundSupported = res.treasureActivityInfo.refundSupported;
    ruleForm.treasureActivityInfo.hasAlbum = res.treasureActivityInfo.hasAlbum
    ruleForm.treasureActivityInfo.albumUrl = res.treasureActivityInfo.albumUrl
    ruleForm.treasureActivityInfo.isSelfOss = res.treasureActivityInfo.isSelfOss
    ruleForm.treasureActivityInfo.visibilityType = res.treasureActivityInfo.visibilityType
    ruleForm.treasureActivityInfo.detailVisibilityType = res.treasureActivityInfo.detailVisibilityType
    ruleForm.treasureActivityInfo.visibilityTagValue = res.treasureActivityInfo.visibilityTagValue
    ruleForm.treasureActivityInfo.startTime = res.treasureActivityInfo.startTime
    ruleForm.treasureActivityInfo.endTime = res.treasureActivityInfo.endTime
    ruleForm.treasureActivityInfo.under16SignupAllowed =
        res.treasureActivityInfo.under16SignupAllowed ?? false
    ruleForm.treasureActivityInfo.activityNotice = res.treasureActivityInfo.activityNotice ?? null
    ruleForm.treasureActivityInfo.activityNoticeEn = res.treasureActivityInfo.activityNoticeEn ?? "Coming Soon ..."
    requirementFields.forEach(field => {
      ruleForm.treasureActivityInfo[field] = normalizeRequirementFormValue(
          res.treasureActivityInfo?.[field],
          ruleForm.treasureActivityInfo[field]
      );
    });
    ruleForm.treasureActivityInfo.certificateTypes = normalizeMultipleValue(res.treasureActivityInfo?.certificateTypes);
    const resInsurance = res.insuranceList ?? res.insurance
    if (Array.isArray(resInsurance)) {
      ruleForm.insuranceList = resInsurance
          .filter(item => item?.insuranceId || item?.id)
          .map(item => ({insuranceId: String(item.insuranceId ?? item.id)}))
    } else if (resInsurance?.insuranceId || resInsurance?.id) {
      ruleForm.insuranceList = [{insuranceId: String(resInsurance.insuranceId ?? resInsurance.id)}]
    } else {
      ruleForm.insuranceList = []
    }
    ruleForm.treasureActivityInfo.insurancePaymentType =
        res.insurance?.insurancePaymentType ?? res.insurancePaymentType ?? "MEMBER_PAY"
    ruleForm.groups = res.groups
    console.log("res", res);
    loading.value = false;
  } catch (e) {
    console.log(e);
    loading.value = false;
  }
};

/*表单相关功能*/
// 表单加载状态
const loading = ref(false);
// 表单锚点
const ruleFormRef = ref();
// 发布活动表单
const ruleForm = reactive({
  queryType: null,
  type: null,
  storeId: null,
  storeName: null,
  goodsId: null,
  bizType: 2,
  goodsName: null,
  goodsNameEn: "Coming Soon ...",
  addressCode: null,
  addressDetail: null,
  addressDetailEn: "Coming Soon ...",
  storeGroup: {
    storeGroupId: null,
  },
  tagList: [],
  description: null,
  descriptionEn: "Coming Soon ...",
  descriptionImages: [],
  descriptionEnImages: [],
  inventory: {
    totalQty: 0,
  },
  retailPrice: 0,
  discoverCoverImage: [],
  images: [],
  treasureActivityInfo: {
    provinceCode: null,
    cityCode: null,
    districtCode: null,
    addressDetail: null,
    addressDetailEn: null,
    visibilityType: null,
    startTime: null,
    endTime: null,
    activityDuration: 1,
    singleSignupLimit: 0,
    emergencyContactRequirement: ["REQUIRED"],
    emergencyContactPhoneRequirement: ["REQUIRED"],
    shippingInfoRequirement: ["REQUIRED"],
    remarkRequirement: ["REQUIRED"],
    certificateRequirement: ["REQUIRED"],
    certificateTypes: [],
    genderRequirement: ["REQUIRED"],
    birthdayRequirement: ["REQUIRED"],
    hasAlbum: false,
    albumUrl: null,
    refundSupported: true,
    isSelfOss: false,
    under16SignupAllowed: false,
    detailVisibilityType: null,
    visibilityTagValue: [],
    activityNotice: null,
    activityNoticeEn: "Coming Soon ...",
    totalParticipantLimit: 0,
    hasTotalParticipantLimit: false,
    insurancePaymentType: "MEMBER_PAY", // PLATFORM_GIFT：BIKING UP平台赠送  MEMBER_PAY：会员支付
  },
  insuranceList: [],
  groups: [],
});
// 活动名称校验规则
const checkGoodsName = (rule, value, callback) => {
  if (!value) {
    return callback(new Error("请输入活动名称（中文）"));
  }
  if (!ruleForm.goodsNameEn) {
    return callback(new Error("请输入活动名称（English）"));
  }
  return callback();
};
// 活动地点校验规则
const checkAddress = (rule, value, callback) => {
  if (!ruleForm.addressCode) return callback(new Error("请选择活动地点省/市/区"));
  if (!ruleForm.addressDetail) return callback(new Error("请填写具体街、地点（中文）"));
  if (!ruleForm.addressDetailEn) return callback(new Error("请填写具体街、地点（English）"));
  return callback();
};
// 活动分组校验规则
const checkStoreGroup = (rule, value, callback) => {
  if (!ruleForm.storeGroup) {
    return callback(new Error("请选择一个活动分组"));
  }
  return callback();
};
// 活动标签校验规则
const checkTagList = (rule, value, callback) => {
  if (ruleForm.tagList.length === 0) return  callback(new Error("请选择一个活动标签"));
  if (ruleForm.tagList.length > 2) {
    return callback(new Error("可选1-2个标签"));
  }
  return callback()
}
// 年龄限制校验规则
const checkAgeLimit = (rule, value, callback) => {
  if (typeof ruleForm.treasureActivityInfo.under16SignupAllowed !== "boolean") {
    return callback(new Error("请选择年龄限制"));
  }
  return callback();
};
// 活动须知校验规则
const checkActivityNotice = (rule, value, callback) => {
  if (!ruleForm.treasureActivityInfo.activityNotice) {
    return callback(new Error("请输入活动须知（中文）"));
  }
  if (!ruleForm.treasureActivityInfo.activityNoticeEn) {
    return callback(new Error("请输入活动须知（English）"));
  }
  return callback();
};
// 活动介绍校验规则
const checkDescription = (rule, value, callback) => {
  if (isEditorEmpty(YTEditorRef)) {
    return callback(new Error("请输入活动相关的介绍描述（中文）"));
  }
  if (isEditorEmpty(YTEditorEnRef)) {
    return callback(new Error("请输入活动相关的介绍描述（English）"));
  }
  return callback();
};
// 活动时间校验规则
const checkActivityTime = (rule, value, callback) => {
  const { startTime, endTime } = ruleForm.treasureActivityInfo;
  if (startTime || endTime) {
    if (!startTime) {
      return callback(new Error("请选择活动开始时间"));
    }
    if (!endTime) {
      return callback(new Error("请选择活动结束时间"));
    }
    if (moment(startTime).isAfter(moment(endTime))) {
      return callback(new Error("活动结束时间不可小于活动开始时间"));
    }
  } else {
    return callback(new Error("请选择活动时间"));
  }
  return callback();
};
// 活动封面图校验规则
const checkImagesList = (rule, value, callback) => {
  const listLength = boxUploadRef.value.fileList.length;
  if (listLength < 1) {
    return callback(new Error("请上传一张活动封面图"));
  }
  return callback();
};
// 人数上限校验规则
const checkInventory = (rule, value, callback) => {
  if (ruleForm.treasureActivityInfo.hasTotalParticipantLimit === 0 || ruleForm.treasureActivityInfo.hasTotalParticipantLimit === null) return callback(new Error("人数上限必须大于0"));
  return callback();
};
// 报名范围活动校验规则
const checkVisibilityType = (rule, value, callback) => {
  if (!ruleForm.treasureActivityInfo.visibilityType) return callback(new Error("请选择报名范围"))
  return callback();
};
// 活动费用校验规则
const checkRetailPrice = (rule, value, callback) => {
  if (value < 0) {
    return callback(new Error("活动费用不能小于0"));
  }
  return callback();
};
// 活动退费规则校验
const checkRefundSupported = (rule, value, callback) => {
  if (ruleForm.treasureActivityInfo.refundSupported === null) {
    return callback(new Error("请选择退费规则"));
  }
  return callback();
};
// 保险产品校验
const checkInsurance = (rule, value, callback) => {
  if (!ruleForm.insuranceList || ruleForm.insuranceList.length === 0) {
    return callback(new Error("请选择保险产品"));
  }
  return callback();
};
const hasSelected = (field) => {
  const value = ruleForm.treasureActivityInfo[field];
  return Array.isArray(value) ? value.length > 0 : Boolean(value);
};
// 会员报名基础表单信息校验
const checkMemberBaseFormInfo = (rule, value, callback) => {
  if (!hasSelected("emergencyContactRequirement")) return callback(new Error("请选择联系人姓名"));
  if (!hasSelected("emergencyContactPhoneRequirement")) return callback(new Error("请选择联系人电话"));
  if (!hasSelected("shippingInfoRequirement")) return callback(new Error("请选择收货信息"));
  if (!hasSelected("remarkRequirement")) return callback(new Error("请选择备注信息"));
  return callback();
};
// 游玩人报名详细表单信息校验
const checkPlayerDetailFormInfo = (rule, value, callback) => {
  if (!hasSelected("certificateRequirement")) return callback(new Error("请选择证件信息"));
  if (!hasSelected("certificateTypes")) return callback(new Error("请选择证件信息类型可选范围"));
  if (!hasSelected("genderRequirement")) return callback(new Error("请选择会员性别信息"));
  if (!hasSelected("birthdayRequirement")) return callback(new Error("请选择会员出生日期"));
  return callback();
};
// 套餐商品分组校验
const checkPackageGroups = (rule, value, callback) => {
  const hasEmptyGroupName = ruleForm.groups.some(item => !item.groupName?.trim() || !item.groupNameEn?.trim());
  if (hasEmptyGroupName) {
    return callback(new Error("请填写套餐商品分组名称（中/英文）"));
  }
  return callback();
};
const checkQueryType = (rule, value, callback) => {
  if (!ruleForm.queryType) return callback(new Error("请选择商家类型"))
  if (!ruleForm.type) return callback(new Error("请选择合作身份"))
  if (!ruleForm.storeId) return callback(new Error("请选择门店"))
  return callback();
}
// 表单校验规则
const rules = ref({
  queryType: [
    { required: true, validator: checkQueryType, trigger: "change" }
  ],
  goodsName: [{ required: true, validator: checkGoodsName, trigger: "blur" }],
  addressCode: [
    { required: true, validator: checkAddress, trigger: ["change", "blur"] },
  ],
  storeGroup: [
    { required: true, validator: checkStoreGroup, trigger: "change" },
  ],
  tagList: [
    { required: true, validator: checkTagList, trigger: "change" }
  ],
  ageLimit: [
    { required: true, validator: checkAgeLimit, trigger: "change" }
  ],
  activityNotice: [
    { required: true, validator: checkActivityNotice, trigger: ["blur", "change"] }
  ],
  description: [
    { required: true, validator: checkDescription, trigger: "blur" },
  ],
  activityTime: [
    {
      required: true,
      validator: checkActivityTime,
      trigger: ["change", "blur"],
    },
  ],
  inventory: [{ required: true, validator: checkInventory, trigger: "blur" }],
  "treasureActivityInfo.activityDuration": [
    { required: true, message: "请输入活动时长", trigger: "blur" }
  ],
  visibilityType: [
    { required: true, validator: checkVisibilityType, trigger: "blur" }
  ],
  retailPrice: [
    { required: true, validator: checkRetailPrice, trigger: "blur" },
  ],
  refundSupported: [
    { required: true, validator: checkRefundSupported, trigger: "blur" }
  ],
  insurance: [
    { required: true, validator: checkInsurance, trigger: "change" }
  ],
  memberBaseFormInfo: [
    { required: true, validator: checkMemberBaseFormInfo, trigger: "change" }
  ],
  playerDetailFormInfo: [
    { required: true, validator: checkPlayerDetailFormInfo, trigger: "change" }
  ],
  groups: [
    { validator: checkPackageGroups, trigger: ["change", "blur"] }
  ],
  images: [{ validator: checkImagesList }],
})
// 处理选择所属区域
const handleSelectAddress = (data) => {
  console.log("data:", data);
  ruleForm.addressCode = data.value;
  ruleForm.treasureActivityInfo.provinceCode = data.value[0];
  ruleForm.treasureActivityInfo.cityCode = data.value[1];
  ruleForm.treasureActivityInfo.districtCode =
      data.value.length === 3 ? data.value[2] : null;
  ruleFormRef.value.validateField("addressCode");
};
// 活动分组选项
const storeGroupsOption = ref([]);
// 活动分组锚点
const YTCheckTagRef = ref();
// 处理获取活动分组
const handleGetStoreGroups = async () => {
  try {
    loading.value = true;
    const res = await listClubCategory({ page: 1, pageSize: 10 });
    storeGroupsOption.value = res.list;
    loading.value = false;
  } catch (e) {
    loading.value = false;
  }
};
// 处理活动分组选中改变
const handleStoreGroupsChange = (checkedOption) => {
  let temp = {
    storeGroupId: null,
  };
  checkedOption.map((i) => {
    if (i.checked) {
      temp.storeGroupId = i.storeGroupId;
    }
  });
  ruleForm.storeGroup = temp.storeGroupId === null ? null : temp;
  ruleFormRef.value.validateField("storeGroup");
};

// 活动标签列表（现在“活动”标签上限10个）
const tagList = ref([])
// 获取活动标签列表
const handleGetActivityTagsList = async (type = 'init') =>  {
  try {
    loading.value = true
    const res = await tagGroupsListByUsageScenario({usageScenario: "TREASURE_ACTIVITY"})
    console.log("res", res)
    if (type === 'init') {
      tagList.value = res
    } else {
      res.map(item => {
        tagList.value.push(item)
      })
    }
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 会员标签列表
const memberTagList = ref([])
// 获取会员标签列表
const handleGetMemberTagsList = async (type = 'init') =>  {
  try {
    dialogLoading.value = true
    const res = await tagGroupsListByUsageScenario({usageScenario: "MEMBER"})
    console.log("res", res)
    if (type === 'init') {
      memberTagList.value = res
    } else {
      res.map(item => {
        memberTagList.value.push(item)
      })
    }
    dialogLoading.value = false
  } catch (e) {
    console.log(e)
    dialogLoading.value = false
  }
}

// 活动开始时间变化时重置结束时间
const handleStartTimeChange = (val, endTime) => {
  if (endTime && new Date(endTime) < new Date(val)) {
    ruleForm.treasureActivityInfo.endTime = null;
  }
};
// 富文本编辑器锚点
const YTEditorRef = ref();
// 富文本编辑器（English）锚点
const YTEditorEnRef = ref();
const isEditorEmpty = (editorRef) => editorRef.value?.isEmpty ? editorRef.value.isEmpty() : true;
// 处理商品描述（中文）富文本赋值给表单
const handleRich2Form = async () => {
  console.log("赋值结果", YTEditorRef.value.getTxtTooLongState());
  if (YTEditorRef.value.getTxtTooLongState()) {
    ElMessage.error("商品描述（中文）内容过长，描述内容请按规定照字数编写。");
    return false;
  }
  ruleForm.description = YTEditorRef.value.getTxt();
  return true;
};
// 处理商品描述（English）富文本赋值给表单
const handleRich2FormEn = async () => {
  console.log("赋值结果", YTEditorEnRef.value.getTxtTooLongState());
  if (YTEditorEnRef.value.getTxtTooLongState()) {
    ElMessage.error(
        "商品描述（English）内容过长，描述内容请按规定照字数编写。"
    );
    return false;
  }
  ruleForm.descriptionEn = YTEditorEnRef.value.getTxt();
  return true;
};
// 活动封面图二上传锚点
const boxUploadRef = ref();
// 处理图片二上传成功
const handlePicSuccess = (url) => {
  ruleForm.images = [];
  ruleForm.images = url;
  ruleFormRef.value.validateField("images");
  loading.value = false;
};
// 处理图片二列表改变
const handleImageRemove = (url) => {
  ruleForm.images = url;
  ruleFormRef.value.validateField("images");
};
// 活动封面图一上传锚点
const boxUploadDiscoverCoverRef = ref();
// 处理图片一上传成功
const handleDiscoverCoverPicSuccess = (url) => {
  ruleForm.discoverCoverImage = [];
  ruleForm.discoverCoverImage = url[0];
  ruleFormRef.value.validateField("discoverCoverImage");
  loading.value = false;
};
// 处理图片一列表改变
const handleDiscoverCoverImageRemove = (url) => {
  ruleForm.discoverCoverImage = url;
  ruleFormRef.value.validateField("discoverCoverImage");
};
// 处理提交时报名表单单选字段格式
const buildSubmitForm = () => {
  const submitForm = {
    ...ruleForm,
    treasureActivityInfo: {
      ...ruleForm.treasureActivityInfo,
    },
  };
  requirementFields.forEach(field => {
    submitForm.treasureActivityInfo[field] = formatRequirementSubmitValue(ruleForm.treasureActivityInfo[field]);
  });
  return submitForm;
};
// 处理表单提交
const handleSubmit = async () => {
  await ruleFormRef.value.validate(async (valid) => {
    if (valid) {
      try {
        loading.value = true;
        // 处理活动地点
        ruleForm.treasureActivityInfo.addressDetail = ruleForm.addressDetail;
        ruleForm.treasureActivityInfo.addressDetailEn = ruleForm.addressDetailEn;
        // 处理富文本内容
        const res = await handleRich2Form();
        if (!res) throw new Errow("商品描述（中文）富文本描述过长");
        const res2 = await handleRich2FormEn();
        if (!res2) throw new Errow("商品描述（English）富文本描述过长");
        // 处理活动描述中富文本的图片地址
        ruleForm.descriptionImages = YTEditorRef.value.getImagesUrlArr();
        ruleForm.descriptionEnImages = YTEditorEnRef.value.getImagesUrlArr();
        // 发起接口请求
        await addTreasureActivity(buildSubmitForm());
        ElMessage.success(isEdit.value ? "修改成功" : "发布成功");
        router.push("/listTreasureHuntActivity");
        loading.value = true;
      } catch (e) {
        console.log(e);
        loading.value = false;
      }
    } else {
      ElMessage.error("请根据提示修改表单信息");
      loading.value = false;
    }
  });
};
// 处理报名范围改变
const handleVisibilityChange = (type) => {
  if (isEdit.value) return ElMessage.error("已发布的活动不允许修改报名范围")
  ruleForm.treasureActivityInfo.visibilityType = type
  console.log("ruleForm.treasureActivityInfo.visibilityType", ruleForm.treasureActivityInfo.visibilityType)
  ruleFormRef.value.validateField("visibilityType");
  // 类型为：邀请可报名。打开选择会员标签弹窗。
  if (type === "SPECIFIED_USER") {
    open.value = true
    handleGetMemberCount()
    handleGetMemberTagsList()
  } else {
    // 否则清空缓存的会员标签信息
    ruleForm.treasureActivityInfo.visibilityTagValue = []
    // 否则detailVisibilityType为'SPECIFIED_USER'，清空活动详情可见范围信息
    if (ruleForm.treasureActivityInfo.detailVisibilityType === 'SPECIFIED_USER') ruleForm.treasureActivityInfo.detailVisibilityType = null
  }
}
// 处理活动详情可见范围改变
const handleDetailVisibilityTypeChange = (type) => {
  if (isEdit.value) return ElMessage.error("已发布的活动不允许修改活动详情可见范围")
  ruleForm.treasureActivityInfo.detailVisibilityType = type
  ruleFormRef.value.validateField("detailVisibilityType");
}
// 处理退费规则改变
const handleRefundSupportedChange = (type) => {
  if (isEdit.value) return ElMessage.error("已发布的活动不允许修改退费规则")
  ruleForm.treasureActivityInfo.refundSupported = type
}

// 展示不可修改报名范围的提示
const handleShowVisibilityError = () => {
  ElMessage.error('已发布的活动不允许修改报名范围')
}
// 处理邀请会员
const handleInviteMemberDialog = async () => {
  open.value = true
  let isReview = ruleForm.treasureActivityInfo.visibilityTagValue.length > 0
  console.log("ruleForm.treasureActivityInfo.visibilityTagValue", ruleForm.treasureActivityInfo.visibilityTagValue)
  await handleGetMemberTagsList()
  // 已选择了标签，做反显
  if (isReview) {
    let reviewList = []
    ruleForm.treasureActivityInfo.visibilityTagValue.map(i => {
      console.log("map i", i)
      console.log("map memberTagList.value", memberTagList.value)
      memberTagList.value.map(tagGroup => {
        const res = tagGroup.tagList.find(tag => tag.tagId === i)
        console.log("map res", res)
        if (res) reviewList.push({tagId: res.tagId, tagName: res.tagName})
      })
    })
    console.log("reviewList", reviewList)
    nextTick(() => {
      // 组件反显
      YTTagSelectDialogRef.value.handleYTCheckTagMultipleReview(reviewList)
    })
    // 输入框反显
    dialogTagList.value = reviewList
  }
  await handleGetMemberCount()
  if (isReview) await handleGetMemberInfoWithTag('init')
}

// 获取当前俱乐部会员总数
const clubMemberCount = ref(0)
const handleGetMemberCount = async () => {
  try {
    dialogLoading.value = true
    const res = await getStoreMemberTotalAdmin(ruleForm.storeId)
    console.log("res", res)
    clubMemberCount.value = parseInt(res)
    dialogLoading.value = false
  } catch (e) {
    console.log(e)
    dialogLoading.value = false
  }
}

// 处理活动相关介绍改变
const handleYTEditorChange = () => {
  ruleFormRef.value.validateField("description")
}

// 处理活动须知改变
const handleActivityNoticeChange = () => {
  ruleFormRef.value.validateField("activityNotice")
}

/*活动标签组件相关*/
// 标签选择器组件锚点
const YTTagSelectRef = ref()
// 活动标签改变
const handleActivityTagChange = (list) => {
  console.log("handleActivityTagChange", list)
  ruleForm.tagList = list.flatMap(i => i.tagList.length > 0 ? i.tagList.filter(tag => tag.checked).map(item => ({ tagId: item.tagId, tagName: item.tagName })) : [])
  ruleFormRef.value.validateField("tagList");
}
// 处理点击活动标签输入框删除按钮
const handleTagListRemoveTag = (tagId) => {
  const resIndex = ruleForm.tagList.findIndex(i => i.tagId === tagId)
  ruleForm.tagList.splice(resIndex, 1)
  YTTagSelectRef.value.handleYTCheckTagMultipleRemove(tagId)
}

/*仅邀请会员可报名。弹窗邀请相关*/
// 弹窗状态
const open = ref(false)
// 弹窗加载状态
const dialogLoading = ref(false)
// 处理邀请弹窗关闭
const handleDialogClose = () => {
  open.value = false
  dialogTagList.value = []
  dialogMemberTotal.value = 0
  clubMemberCount.value = 0
  dialogMemberList.value = []
  dialogPage.value = 1
}
// 弹窗的标签选择器锚点
const YTTagSelectDialogRef = ref()
// 弹窗邀请已选择的标签列表
const dialogTagList = ref([])
// 弹窗邀请标签改变
const handleDialogTagChange = async (list) => {
  dialogTagList.value = list.flatMap(i => i.tagList.length > 0 ? i.tagList.filter(tag => tag.checked).map(item => ({ tagId: item.tagId, tagName: item.tagName })) : [])
  await handleGetMemberInfoWithTag("init")
}
// 处理弹窗点击删除标签
const handleRemoveDialogTag = (tagId) =>{
  const resIndex = dialogTagList.value.findIndex(i => i.tagId === tagId)
  dialogTagList.value.splice(resIndex, 1)
  YTTagSelectDialogRef.value.handleYTCheckTagMultipleRemove(tagId)
  handleGetMemberInfoWithTag()
}
// 查询出的会员信息
const dialogMemberList = ref([])
// 查询出的会员总条数
const dialogMemberTotal = ref(0)
// 当前页
const dialogPage = ref(1)
// 单页长度
const dialogPageSize = ref(10)
// 输入框的当前页数
const pageInput = ref('1');
// 处理弹窗翻页输入
const handleDialogPageInput = (event) => {
  // 实时过滤非数字
  const numbersOnly = event.target.value.replace(/[^\d]/g, '');
  pageInput.value = numbersOnly;
  dialogPage.value = parseInt(numbersOnly) || 1;
};
// 处理弹窗翻页当前页数改变
const handleDialogPageChange = () => {
  const maxPage = Math.ceil(dialogMemberTotal.value / dialogPageSize.value);
  let finalPage = parseInt(pageInput.value) || 1;
  // 边界检查
  if (finalPage > maxPage) finalPage = maxPage;
  if (finalPage < 1) finalPage = 1;
  // 同步更新两个值
  dialogPage.value = finalPage;
  pageInput.value = finalPage.toString();
}
// 处理弹窗翻页按钮
const handleDialogPageBtnChange = (type) => {
  const totalPage = Math.ceil(dialogMemberTotal.value / dialogPageSize.value)
  if (type === 'plus') {
    const resPage = dialogPage.value + 1
    console.log("resPage", resPage)
    console.log("totalPage", totalPage)
    console.log("resPage > totalPage", resPage > totalPage)
    if (resPage > totalPage) return
    dialogPage.value++
  } else {
    const resPage = dialogPage.value - 1
    if (resPage < 1) return
    dialogPage.value--
  }
  pageInput.value = dialogPage.value
  handleGetMemberInfoWithTag('turn')
}
// 根据标签获取会员信息
const handleGetMemberInfoWithTag = async (type) => {
  if (type === 'init') dialogPage.value = 1
  try {
    let page = {
      page: dialogPage.value,
      pageSize: dialogPageSize.value
    }
    let param = []
    dialogTagList.value.map(i => {
      param.push(i.tagId)
    })
    dialogLoading.value = true
    let res = null
    if (isEdit.value) {
      res = await listStoreMemberTagChecked(page, ruleForm.goodsId)
    } else {
      res = await getStoreMemberListWithTagAdmin(page, {tagIdList: param}, ruleForm.storeId)
    }
    console.log("Res", res)
    dialogMemberList.value = res.list
    dialogMemberTotal.value = parseInt(res.total)
    dialogLoading.value = false
  } catch (e) {
    console.log(e)
    dialogLoading.value = false
  }
}
// 处理弹窗表格中标签名称展示内容为String
const handleShowTagList = (list) => {
  let temp = []
  try {
    list.map(i => temp.push(i.tagName))
  } catch (e) {
    console.log(e)
  }
  return temp.join("、")
}
// 处理弹窗选择的标签信息
const handleDialogSubmit = () => {
  let temp = []
  dialogTagList.value.map(i => temp.push(i.tagId))
  ruleForm.treasureActivityInfo.visibilityTagValue = temp
  handleDialogClose()
}

// 封面图实例弹窗打开状态
const openExamples = ref(false)
// 处理展示封面图示例
const handleShowExamples = () => {
  openExamples.value = true
}

// 处理人数上限修改
const handleInventoryChange = () => {
  ruleFormRef.value.validateField("inventory");
}

// 处理表单字段静默校验
const validateFieldSilently = (field) => {
  const validateTask = ruleFormRef.value?.validateField(field);
  if (validateTask && typeof validateTask.catch === "function") {
    validateTask.catch(() => {});
  }
}

// 处理报名表单单选项修改
const handleRequirementSingleChange = (field, list, validateField) => {
  const current = ruleForm.treasureActivityInfo[field]?.[0];
  const next = list.find(item => item !== current) || list[0];
  ruleForm.treasureActivityInfo[field] = next ? [next] : [];
  validateFieldSilently(validateField);
}

// 处理添加套餐商品分组
const handleAddPackageGroup = () => {
  // 已有分组中英文名称未填写时，不允许继续新增分组
  const hasEmptyGroupName = ruleForm.groups.some(item => !item.groupName || !item.groupNameEn);
  if (hasEmptyGroupName) {
    ElMessage.error("请先填写已有分组名称（中/英文）");
    return;
  }
  ruleForm.groups.push({
    groupName: null,
    groupNameEn: null,
    groupType: "FIXED",
    items: [],
  });
  packageGroupNameTab.value.push("zh");
  validateFieldSilently("groups");
}

// 处理删除套餐商品分组
const handleRemovePackageGroup = (index) => {
  ruleForm.groups.splice(index, 1);
  packageGroupNameTab.value.splice(index, 1);
  validateFieldSilently("groups");
}

// 处理删除套餐分组中的商品
const handleRemoveMerchandiseItem = (goodsId) => {
  ruleForm.groups.forEach(group => {
    group.items = group.items.filter(item => item.goodsId !== goodsId);
  });
}

// 套餐商品列表
const packageGoodsList = ref([])
// 套餐商品加载状态
const packageGoodsLoading = ref(false)
// 是否打开套餐商品选择弹窗
const openPackageGoodsList = ref(false)
// 套餐商品搜索关键词
const cachePackageGoodsKeyword = ref("")
// 套餐商品分页
const packageGoodsPage = ref(1)
// 套餐商品分页大小
const packageGoodsPageSize = ref(5)
// 套餐商品总数
const totalPackageGoods = ref(0)
// 套餐商品选择面板锚点
const packageGoodsPanelRef = ref(null)
// 当前选择的套餐商品id
const cachePackageGoodsSelectId = ref("")
// 当前添加商品的套餐分组下标
const cachePackageGroupIndex = ref(null)
// 获取套餐商品列表
const handleGetPackageGoodsList = async () => {
  const page = {
    page: packageGoodsPage.value,
    pageSize: packageGoodsPageSize.value,
  }
  const data = {
    keyword: cachePackageGoodsKeyword.value,
    tenantId: null,
    categoryTypes: ['DEFAULT', 'STICKER', 'SERVICE', 'COURSE', 'NUMBER', 'VOUCHER', 'COUPON', 'THERAPY_SERVICE', 'COMPETITION_OFFICIAL_SERVICE', 'PHOTOGRAPHY', 'BIKE_MAINTENANCE', 'VENUE_COURSE', 'APPOINTMENT_SERVICE', 'ENTRY_APPOINTMENT', 'MALL']
  }
  try {
    packageGoodsLoading.value = true
    const res = await itemListIgnore(page, data)
    packageGoodsList.value = res.list.map(item => ({
      name: item.goodsName,
      value: item.goodsId,
    }))
    totalPackageGoods.value = Number(res.total)
  } finally {
    packageGoodsLoading.value = false
  }
}
// 处理打开套餐商品选择弹窗
const handleOpenPackageGoodsList = (index) => {
  cachePackageGroupIndex.value = index
  openPackageGoodsList.value = true
  handleGetPackageGoodsList()
}
// 处理套餐商品选择弹窗关闭
const handlePackageGoodsListClose = () => {
  openPackageGoodsList.value = false
  cachePackageGoodsSelectId.value = ""
}
// 处理套餐商品选择弹窗确认
const handlePackageGoodsListConfirm = async () => {
  openPackageGoodsList.value = false
  if (cachePackageGoodsSelectId.value && cachePackageGroupIndex.value !== null) {
    const group = ruleForm.groups[cachePackageGroupIndex.value]
    if (group && !group.items.some(item => item.goodsId === cachePackageGoodsSelectId.value)) {
      const res = await itemDetail(cachePackageGoodsSelectId.value)
      group.items.push({
        goodsId: res.goodsId,
        goodsName: res.goodsName,
        depositRequired: false,
        depositAmount: null,
        fixedCount: 1,
      })
    }
  }
  cachePackageGoodsSelectId.value = ""
}
// 处理套餐商品选择
const handlePackageGoodsSelect = (item) => {
  cachePackageGoodsSelectId.value = item[0]
}
// 处理套餐商品搜索
const handlePackageGoodsSearch = () => {
  packageGoodsPage.value = 1
  packageGoodsPanelRef.value.handleClearCacheSelect()
  handleGetPackageGoodsList()
}
// 处理套餐商品分页
const handlePackageGoodsPageChange = () => {
  packageGoodsPanelRef.value.handleClearCacheSelect()
  handleGetPackageGoodsList()
}

// 保险产品列表
const insuranceProductList = ref([])
// 保险产品加载状态
const insuranceLoading = ref(false)
// 保险产品总数
const insuranceTotal = ref(0)
// 获取保险产品id
const getInsuranceId = (item) => item?.insuranceId ?? item?.id
// 获取保险回显id
const getInsuranceEchoId = (data = {}) => {
  return data.insurance?.insuranceId ?? data.insurance?.id ?? data.insuranceId ?? null
}
// 判断保险产品是否已选中
const isInsuranceProductChecked = (row) => {
  const rowInsuranceId = String(getInsuranceId(row))
  return ruleForm.insuranceList.some(item => String(item.insuranceId) === rowInsuranceId)
}
// 获取保险产品列表
const handleGetInsuranceList = async () => {
  try {
    const param = {
      page: 1,
      pageSize: 999
    }
    insuranceLoading.value = true
    const res = await listInsurance(param, {insuranceState: 'ON_SHELF'})
    insuranceProductList.value = res.list || []
    insuranceTotal.value = parseInt(res.total || 0)
    insuranceLoading.value = false
  } catch (e) {
    console.log(e)
    insuranceLoading.value = false
  }
}
// 处理保险保障期限展示
const handleInsuranceDuration = (row) => {
  const unit = insuranceDurationUnitEnum.find(item => item.stateId === row.insuranceDurationUnit)?.stateName || ""
  return `${row.insuranceDuration || ""}${unit}`
}
// 处理保险价格展示
const handleInsurancePrice = (row) => row.price ?? `￥${row.insurancePrice}` ?? "-"

// 处理保险产品选择
const handleInsuranceProductChange = (row, checked) => {
  const id = String(getInsuranceId(row))
  if (checked) {
    if (!ruleForm.insuranceList.some(item => String(item.insuranceId) === id)) {
      ruleForm.insuranceList.push({insuranceId: id})
    }
  } else {
    const index = ruleForm.insuranceList.findIndex(item => String(item.insuranceId) === id)
    if (index !== -1) {
      ruleForm.insuranceList.splice(index, 1)
    }
  }
  const validateTask = ruleFormRef.value?.validateField("insurance");
  if (validateTask && typeof validateTask.catch === "function") {
    validateTask.catch(() => {});
  }
}

/*中英文切换输入框相关Tab*/
// 活动名称tab
const goodsNameTab = ref("zh");
// 活动地点tab
const addressDetailTab = ref("zh")
// 活动须知tab
const activityNoticeTab = ref("zh")
// 活动介绍描述
const descriptionTab = ref("zh")
// 套餐商品分组名称tab
const packageGroupNameTab = ref([])

/*选择商家相关*/
const props = {
  value: 'id',
  label: 'label',
  options: 'options',
  disabled: 'disabled',
}
// 商家类型枚举
const storeTypeEnum = [
  {
    id: 'BIKING_UP',
    label: 'BIKING UP',
  },
  {
    id: 'NOT_BIKING_UP',
    label: '其他商家',
  },
]
// 合作身份类型枚举
const tenantRolesEnum = [
  {
    id: 'CLUB',
    label: '俱乐部',
  },
  {
    id: 'STORE',
    label: '驿站',
  },
  {
    id: 'VENUE',
    label: '场地',
  },
  {
    id: 'BIKE_STORE',
    label: '车店',
  },
  {
    id: 'THERAPIST_STORE',
    label: '理疗服务商',
  },
  {
    id: 'PHOTOGRAPHY_STORE',
    label: '摄影服务商',
  },
]

// 处理商家类型修改
const handleQueryTypeChange = () => {
  ruleForm.type = null
  ruleForm.storeId = null
}
// 处理合作身份修改
const handleTypeChange = () => {
  ruleForm.storeId = null
}

/*门店列表相关*/
// 门店列表
const storeList = ref([])
// 门店列表加载状态
const storeLoading = ref(false)
// 门店总数
const totalStore = ref(0)
// 门店列表当前页数
const pageStore = ref(1)
// 门店列表页长
const pageSizeStore = ref(5)
// 处理选择门店改变
const handleStoreChange = (e) => {
  const store = storeList.value.find(item => item.storeId === e)
  ruleForm.storeId = store.storeId
  ruleForm.storeName = store.name
}
// 处理门店翻页
const handleChangeStorePage = (e) => {
  pageStore.value = e
  handleGetStoreList()
}
// 搜索关键字缓存
const keywordStore = ref()
// 搜索触发函数
const handleRemoteSearch = (keyword) => {
  keywordStore.value = keyword
  pageStore.value = 1
  handleGetStoreList()
}
// 获取门店列表
const handleGetStoreList = async () => {
  storeLoading.value = true
  const page = {
    page: pageStore.value,
    pageSize: pageSizeStore.value,
  }
  let param = {
    keyword: keywordStore.value || null,
    type: ruleForm.type,
    assistsOperation: ruleForm.queryType === "BIKING_UP" ? null : true,
    queryType: ruleForm.queryType
  }
  const res = await listTenantOrganizeIgnore(page, param)
  storeList.value = res.list
  totalStore.value = parseInt(res.total)
  console.log(res)
  storeLoading.value = false
}

// 处理选择创建直播相册
const handleSelectLiveAlbum = () => {
  if (ruleForm.treasureActivityInfo.hasAlbum && !ruleForm.treasureActivityInfo.isSelfOss) {
    ruleForm.treasureActivityInfo.hasAlbum = false
    ruleForm.treasureActivityInfo.isSelfOss = false
    ruleForm.treasureActivityInfo.albumUrl = null
    return
  }
  ruleForm.treasureActivityInfo.hasAlbum = true
  if (ruleForm.treasureActivityInfo.hasAlbum) ruleForm.treasureActivityInfo.isSelfOss = false
  ruleFormRef.value.validateField("album")
  console.log("ruleForm.treasureActivityInfo.hasAlbum", ruleForm.treasureActivityInfo.hasAlbum)
}
// 处理选择创建非直播相册
const handleSelectNonLiveAlbum = () => {
  if (ruleForm.treasureActivityInfo.hasAlbum && ruleForm.treasureActivityInfo.isSelfOss) {
    ruleForm.treasureActivityInfo.hasAlbum = false
    ruleForm.treasureActivityInfo.isSelfOss = false
    return
  }
  ruleForm.treasureActivityInfo.hasAlbum = true
  if (ruleForm.treasureActivityInfo.hasAlbum) ruleForm.treasureActivityInfo.isSelfOss = true
  ruleFormRef.value.validateField("album")
}
// 处理活动相册失焦
const handleAlbumUrlBlur = () => {
  ruleFormRef.value.validateField("album")
}

/*证件类型相关*/
// 证件类型枚举
const certificateTypeOption = ref(certificateTypeEnum);
</script>

<template>
  <el-form
      ref="ruleFormRef"
      :model="ruleForm"
      :rules="rules"
      style="height: 100%"
  >
    <div
        class="container_box flex"
        style="height: 100%; min-width: 950px;padding-bottom: 16px;"
        v-loading="loading"
    >
      <div class="activity_upload_box" style="border-right: 1px solid #dfdfdf">
        <YTCard :title="`活动封面图`" :isRetract="false" :isShowDivider="false" :isShowExamples="true" @click-title-after="handleShowExamples">
          <template #container>
            <div style="margin-top: 24px">
              <el-form-item prop="discoverCoverImage">
                <BoxUpload
                    :isReplaceMode="true"
                    :isRequired="true"
                    ref="boxUploadDiscoverCoverRef"
                    :ali-oss-path="'GOODS_DISCOVER_COVER_IMAGE'"
                    :width="280"
                    :height="280"
                    :limit="1"
                    :file-size="1"
                    :coverName="'封面一'"
                    @progress="loading = true"
                    @remove="handleDiscoverCoverImageRemove"
                    @success="handleDiscoverCoverPicSuccess"
                ></BoxUpload>
              </el-form-item>
              <el-form-item prop="images">
                <BoxUpload
                    :isReplaceMode="true"
                    :isRequired="true"
                    ref="boxUploadRef"
                    :ali-oss-path="'GOODS_IMG_PATH'"
                    :width="139"
                    :height="83"
                    :limit="1"
                    :file-size="1"
                    :coverName="'封面二'"
                    @progress="loading = true"
                    @remove="handleImageRemove"
                    @success="handlePicSuccess"
                ></BoxUpload>
              </el-form-item>
            </div>
          </template>
        </YTCard>
      </div>
      <div class="w-100 activity_content_box" style="padding-top: 63px;">
        <div
            id="activityContainer"
            class="activity_form_box"
            style="padding: 0 20px; box-sizing: border-box;"
        >
          <div class="activity_form_inner" style="max-width: 1000px;">
            <YTCard :isShowDivider="false" :title="`基础信息`" id="basic">
              <template #container>
                <el-form-item label="选择商家：" prop="queryType">
                  <div class="flex" style="gap: 20px">
                    <el-select
                        v-model="ruleForm.queryType"
                        :props="props"
                        placeholder="商家类型"
                        style="width: 180px"
                        @change="handleQueryTypeChange"
                        :disabled="isEdit"
                    >
                      <el-option
                          v-for="item in storeTypeEnum"
                          :key="item.id"
                          :label="item.label"
                          :value="item.id"
                      />
                    </el-select>
                    <el-select
                        v-model="ruleForm.type"
                        :props="props"
                        placeholder="合作身份"
                        style="width: 180px"
                        @change="handleTypeChange"
                        :disabled="ruleForm.queryType === null || isEdit"
                    >
                      <el-option
                          v-for="item in tenantRolesEnum"
                          :key="item.id"
                          :label="item.label"
                          :value="item.id"
                      />
                    </el-select>
                    <el-select
                        v-model="ruleForm.storeId"
                        placeholder="门店"
                        style="width: 180px;"
                        :loading="storeLoading"
                        @change="handleStoreChange"
                        filterable
                        remote
                        remote-show-suffix
                        :disabled="ruleForm.type === null || isEdit"
                        :remote-method="handleRemoteSearch"
                    >
                      <el-option
                          v-for="item in storeList"
                          :key="`storeId${item.storeId}`"
                          :label="item.name"
                          :value="item.storeId"
                      />
                      <template v-if="!loading && !storeList.some(res => res.storeId === ruleForm.storeId) && ruleForm.storeId" #header>
                        当前已选：
                        <el-option
                            :label="ruleForm.storeName"
                            :value="ruleForm.storeId"
                        />
                      </template>

                      <template #footer>
                        <div class="flex_center">
                          <el-pagination
                              size="small"
                              background
                              layout="prev, pager, next"
                              :total="totalStore"
                              class="mt-4"
                              v-model:current-page="pageStore"
                              v-model:page-size="pageSizeStore"
                              @current-change="handleChangeStorePage"
                          />
                        </div>
                      </template>
                    </el-select>

                  </div>
                </el-form-item>
                <el-form-item label="活动名称：" prop="goodsName">
                  <div class="flex_center flex_left w-100">
                    <el-input
                        v-model="ruleForm.goodsName"
                        v-show="goodsNameTab === 'zh'"
                        :class="
                      ruleForm.goodsName === null || ruleForm.goodsName === ''
                        ? 'input-null mg_r_2'
                        : 'input-filled mg_r_2'
                    "
                        style="height: 36px"
                        placeholder="活动名称"
                    ></el-input>
                    <el-input
                        v-model="ruleForm.goodsNameEn"
                        v-show="goodsNameTab === 'en'"
                        :class="
                      ruleForm.goodsNameEn === null || ruleForm.goodsNameEn === ''
                        ? 'input-null mg_r_2'
                        : 'input-filled mg_r_2'
                    "
                        style="height: 36px"
                        placeholder="activity name"
                    ></el-input>
                    <YTI18NTabs v-model="goodsNameTab"></YTI18NTabs>
                  </div>
                </el-form-item>
                <el-form-item label="活动时间：" prop="activityTime">
                  <div class="flex" style="width: 100%; padding-right: 20px">
                    <el-date-picker
                        :class="
                        ruleForm.treasureActivityInfo.startTime === null ||
                        ruleForm.treasureActivityInfo.startTime === ''
                          ? 'input-null mg_r_2'
                          : 'input-filled mg_r_2'
                      "
                        v-model="ruleForm.treasureActivityInfo.startTime"
                        type="datetime"
                        placeholder="选择开始日期与时间"
                        format="YYYY-MM-DD HH:mm:ss"
                        @change="
                        (val) => handleStartTimeChange(val, ruleForm.treasureActivityInfo.endTime)
                      "
                        :teleported="false"
                    />
                    <el-date-picker
                        :class="
                        ruleForm.treasureActivityInfo.endTime === null ||
                        ruleForm.treasureActivityInfo.endTime === ''
                          ? 'input-null'
                          : 'input-filled'
                      "
                        v-model="ruleForm.treasureActivityInfo.endTime"
                        type="datetime"
                        placeholder="选择结束日期与时间"
                        format="YYYY-MM-DD HH:mm:ss"
                        :disabled-date="
                        (time) => disabledEndDate(time, ruleForm.treasureActivityInfo.startTime)
                      "
                        :teleported="false"
                    />
                  </div>
                </el-form-item>
                <el-form-item label="活动地点：" prop="addressCode">
                  <div
                      class="flex_left w-100"
                      style="box-sizing: border-box; padding-right: 20px"
                  >
                    <div class="flex_left w-100">
                      <div style="width: 210px">
                        <YTAddress
                            :placeholder="`省/市/区`"
                            class="mg_r_2"
                            :addressCode="ruleForm.addressCode"
                            @select="handleSelectAddress"
                        ></YTAddress>
                      </div>
                      <div class="flex_left" style="flex: 1">
                        <el-input
                            v-show="addressDetailTab === 'zh'"
                            v-model="ruleForm.addressDetail"
                            :class="
                          ruleForm.addressDetail === null ||
                          ruleForm.addressDetail === ''
                            ? 'input-null'
                            : 'input-filled'
                        "
                            style="
                          max-width: 780px;
                          height: 36px;
                          display: flex;
                          flex-wrap: nowrap;
                          align-items: center;
                          margin-right: 20px;
                        "
                            placeholder="请填写具体街、地点"
                        ></el-input>
                        <el-input
                            v-show="addressDetailTab === 'en'"
                            v-model="ruleForm.addressDetailEn"
                            :class="
                          ruleForm.addressDetailEn === null ||
                          ruleForm.addressDetailEn === ''
                            ? 'input-null'
                            : 'input-filled'
                        "
                            style="
                          max-width: 780px;
                          height: 36px;
                          display: flex;
                          flex-wrap: nowrap;
                          align-items: center;
                          margin-right: 20px;
                        "
                            placeholder="Please fill in the specific street and location"
                        ></el-input>
                        <YTI18NTabs v-model="addressDetailTab"></YTI18NTabs>
                      </div>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="活动分组：" prop="storeGroup">
                  <YTCheckTag
                      ref="YTCheckTagRef"
                      :limit="1"
                      :options="storeGroupsOption"
                      @change="handleStoreGroupsChange"
                  ></YTCheckTag>
                </el-form-item>
                <el-form-item label="活动标签：" prop="tagList">
                  <YTTagSelect ref="YTTagSelectRef" :selectedCount="ruleForm.tagList.length" :width="416" :tagList="tagList" @tagChange="handleActivityTagChange">
                    <template #trigger="{ toggle, visible }">
                      <div @click="toggle">
                        <div :class="['yt_tag_select_box', ruleForm.tagList.length === 0
                            ? 'input-null'
                            : 'input-filled'
                        ]">
                          <div class="el-select__wrapper flex_left">
                            <div style="flex:1">
                              <div class="yt_tag_select_placeholder" v-if="ruleForm.tagList.length === 0">可选择1-2个标签</div>
                              <div v-else>
                                <span class="yt_tag_select_tag" v-for="(item, index) in ruleForm.tagList" :key="`tagListInput${index}`">
                                  {{item.tagName}}
                                  <img @click.stop="handleTagListRemoveTag(item.tagId)" style="width: 10px;height: 10px;margin-left: 5px;" src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/activity/activity/tag_remove.svg"/>
                                </span>
                              </div>
                            </div>
                            <div class="yt_tag_select_suffix">
                              <img class="yt_tag_select_suffix_icon" src="@/assets/images/filter/select-arrowDown.svg" :class="{reverse: visible}"/>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </YTTagSelect>
                </el-form-item>
                <el-form-item label="年龄限制：" prop="ageLimit">
                  <div class="flex_left mg_r_3" style="cursor: not-allowed;">
                    <div style="margin-right: 13px">
                      <YTRadio
                          :show="ruleForm.treasureActivityInfo.under16SignupAllowed === true"
                          :disabled="true"
                      ></YTRadio>
                    </div>
                    <div style="font-size: 16px" class="tips">
                      支持16周岁以下单独报名
                    </div>
                  </div>
                  <div class="flex_left">
                    <div style="margin-right: 13px">
                      <YTRadio
                          :show="ruleForm.treasureActivityInfo.under16SignupAllowed === false"
                      ></YTRadio>
                    </div>
                    <div style="font-size: 16px" class="tips">
                      不支持16周岁以下单独报名
                    </div>
                  </div>
                </el-form-item>
                <el-form-item
                    label="活动须知（即超时计费规则）："
                    label-position="top"
                    prop="activityNotice"
                >
                  <div style="width: 100%">
                    <YTI18NTabs v-model="activityNoticeTab"></YTI18NTabs>
                    <div v-show="activityNoticeTab === 'zh'" style="margin: 15px 0">
                      <el-input
                          v-model="ruleForm.treasureActivityInfo.activityNotice"
                          type="textarea"
                          maxlength="500"
                          show-word-limit
                          :autosize="{ minRows: 4, maxRows: 8 }"
                          placeholder="请输入活动须知（即超时计费规则）"
                          @blur="handleActivityNoticeChange"
                          resize="none"
                      ></el-input>
                    </div>
                    <div v-show="activityNoticeTab === 'en'" style="margin: 15px 0">
                      <el-input
                          v-model="ruleForm.treasureActivityInfo.activityNoticeEn"
                          type="textarea"
                          maxlength="1500"
                          show-word-limit
                          :autosize="{ minRows: 4, maxRows: 8 }"
                          placeholder="Please enter activity notice"
                          @blur="handleActivityNoticeChange"
                          resize="none"
                      ></el-input>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item
                    label="输入活动相关的介绍描述："
                    label-position="top"
                    prop="description"
                >
                  <div>
                    <YTI18NTabs v-model="descriptionTab"></YTI18NTabs>
                    <div v-show="descriptionTab === 'zh'" style="margin: 15px 0">
                      <YTEditor
                          :ali-oss-path="'GOODS_DETAIL_PATH'"
                          ref="YTEditorRef"
                          :max-pic-size="3"
                          :title="'商品描述（中文）'"
                          :maxLength="2000"
                          :reviewTxt="ruleForm.description"
                          @change="handleYTEditorChange"
                      ></YTEditor>
                    </div>
                    <div v-show="descriptionTab === 'en'" style="margin: 15px 0">
                      <YTEditor
                          :ali-oss-path="'GOODS_DETAIL_PATH'"
                          ref="YTEditorEnRef"
                          :max-pic-size="3"
                          :title="'商品描述（English）'"
                          :maxLength="6000"
                          :reviewTxt="ruleForm.descriptionEn"
                          @change="handleYTEditorChange"
                      ></YTEditor>
                    </div>
                  </div>
                </el-form-item>
              </template>
            </YTCard>
            <YTCard :isShowDivider="false" :title="`报名信息`" id="signup">
              <template #container>
                <el-form-item label="总人数上限：" prop="inventory" style="margin-bottom: 20px;">
                  <div class="father_box flex" style="gap: 30px;">
                    <div>
                      <div class="flex_left cursor-pointer" @click="ruleForm.treasureActivityInfo.hasTotalParticipantLimit = true">
                        <div style="margin-right: 13px">
                          <YTRadio
                              :show="ruleForm.treasureActivityInfo.hasTotalParticipantLimit"
                          ></YTRadio>
                        </div>
                        <div style="font-size: 16px" class="tips">
                          有
                        </div>
                      </div>
                    </div>
                    <div class="flex" v-show="ruleForm.treasureActivityInfo.hasTotalParticipantLimit">
                      <el-input-number
                          :min="1"
                          :max="100000"
                          :precision="0"
                          v-model="ruleForm.treasureActivityInfo.totalParticipantLimit"
                          :class="
                          ruleForm.treasureActivityInfo.totalParticipantLimit === null ||
                          ruleForm.treasureActivityInfo.totalParticipantLimit === 0
                            ? 'input-null'
                            : 'input-filled'
                        "
                          style="width: 180px; height: 36px"
                          placeholder="人数上限"
                          @change="handleInventoryChange"
                          @blur="handleInventoryChange"
                      ></el-input-number>
                      <div
                          style="
                          font-weight: 500;
                          font-size: 18px;
                          color: #272539;
                          margin-left: 15px;
                        "
                      >
                        人
                      </div>
                    </div>
                    <div>
                      <div class="flex_left cursor-pointer" @click="ruleForm.treasureActivityInfo.hasTotalParticipantLimit = false">
                        <div style="margin-right: 13px">
                          <YTRadio
                              :show="!ruleForm.treasureActivityInfo.hasTotalParticipantLimit"
                          ></YTRadio>
                        </div>
                        <div style="font-size: 16px" class="tips">
                          无
                        </div>
                      </div>
                    </div>
                  </div>
                </el-form-item>
                <div class="flex tips" style="margin-bottom: 20px;">
                  <img
                      style="width: 18px; height: 18px; margin-right: 10px"
                      src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/common/common/tips.svg"
                  />
                  <div>
                    人数最高可填10万人
                  </div>
                </div>
                <el-form-item label="单次报名人数上限：" style="margin-bottom: 20px">
                  <el-input-number
                      :min="1"
                      :max="100000"
                      :precision="0"
                      v-model="ruleForm.treasureActivityInfo.singleSignupLimit"
                      :class="
                          ruleForm.treasureActivityInfo.singleSignupLimit === null ||
                          ruleForm.treasureActivityInfo.singleSignupLimit === 0
                            ? 'input-null'
                            : 'input-filled'
                        "
                      style="width: 180px; height: 36px"
                      placeholder="请输入"
                  ></el-input-number>
                  <div
                      style="
                          font-weight: 500;
                          font-size: 18px;
                          color: #272539;
                          margin-left: 15px;
                        "
                  >
                    人
                  </div>
                </el-form-item>
                <el-form-item label="报名范围：" prop="visibilityType" style="margin-bottom: 20px;">
                  <div class="flex_bt" v-if="!isEdit">
                    <div v-if="ruleForm.treasureActivityInfo.visibilityType !== 'PUBLIC'">
                      <el-popconfirm
                          width="288"
                          @confirm="handleVisibilityChange('PUBLIC')"
                          :title="`报名范围设置为“全平台公开”吗？活动发布后，将无法再次修改`"
                      >
                        <template #reference>
                          <div class="flex_left mg_r_3 cursor-pointer">
                            <div style="margin-right: 13px">
                              <YTRadio
                                  :show="ruleForm.treasureActivityInfo.visibilityType === 'PUBLIC'"
                              ></YTRadio>
                            </div>
                            <div style="font-size: 16px" class="tips">
                              全平台公开
                            </div>
                          </div>
                        </template>
                        <template #actions="{ confirm, cancel }">
                          <div class="flex_right">
                            <v-btn class="mg_r_2" size="small" @click="cancel">取消</v-btn>
                            <v-btn size="small" color="#796CB4" @click="confirm"
                            >确定</v-btn
                            >
                          </div>
                        </template>
                      </el-popconfirm>
                    </div>
                    <div v-else>
                      <div class="flex_left mg_r_3 cursor-pointer" @click="handleVisibilityChange('PUBLIC')">
                        <div style="margin-right: 13px">
                          <YTRadio
                              :show="ruleForm.treasureActivityInfo.visibilityType === 'PUBLIC'"
                          ></YTRadio>
                        </div>
                        <div style="font-size: 16px" class="tips">
                          全平台公开
                        </div>
                      </div>
                    </div>
                    <div v-if="ruleForm.treasureActivityInfo.visibilityType !== 'MEMBER_VISIBLE'">
                      <el-popconfirm
                          width="288"
                          @confirm="handleVisibilityChange('MEMBER_VISIBLE')"
                          :title="`报名范围设置为“仅商家自身会员可报名”吗？活动发布后，将无法再次修改`"
                      >
                        <template #reference>
                          <div class="flex_left mg_r_3 cursor-pointer">
                            <div style="margin-right: 13px">
                              <YTRadio
                                  :show="ruleForm.treasureActivityInfo.visibilityType === 'MEMBER_VISIBLE'"
                              ></YTRadio>
                            </div>
                            <div style="font-size: 16px" class="tips">
                              仅商家自身会员可报名
                            </div>
                          </div>
                        </template>
                        <template #actions="{ confirm, cancel }">
                          <div class="flex_right">
                            <v-btn class="mg_r_2" size="small" @click="cancel">取消</v-btn>
                            <v-btn size="small" color="#796CB4" @click="confirm"
                            >确定</v-btn
                            >
                          </div>
                        </template>
                      </el-popconfirm>
                    </div>
                    <div v-else>
                      <div class="flex_left mg_r_3 cursor-pointer">
                        <div style="margin-right: 13px" @click="handleVisibilityChange('MEMBER_VISIBLE')">
                          <YTRadio
                              :show="ruleForm.treasureActivityInfo.visibilityType === 'MEMBER_VISIBLE'"
                          ></YTRadio>
                        </div>
                        <div style="font-size: 16px" class="tips">
                          仅商家自身会员可报名
                        </div>
                      </div>
                    </div>
                    <div v-if="ruleForm.treasureActivityInfo.visibilityType !== 'SPECIFIED_USER'">
                      <el-popconfirm
                          width="288"
                          @confirm="handleVisibilityChange('SPECIFIED_USER')"
                          :title="`报名范围设置为“仅被邀请会员可报名”吗？活动发布后，将无法再次修改`"
                      >
                        <template #reference>
                          <div style="z-index: 10;position: relative">
                            <div :class="['flex_left', 'mg_r_3', 'cursor-pointer', {visibility_active : ruleForm.treasureActivityInfo.visibilityType === 'SPECIFIED_USER'}]">
                              <div style="margin-right: 13px">
                                <YTRadio
                                    :show="ruleForm.treasureActivityInfo.visibilityType === 'SPECIFIED_USER'"
                                ></YTRadio>
                              </div>
                              <div style="font-size: 16px" class="tips">
                                仅被邀请会员可报名
                              </div>
                              <div @click="handleInviteMemberDialog" v-if="ruleForm.treasureActivityInfo.visibilityType === 'SPECIFIED_USER'" class="visibility_active_view_box cursor-pointer">
                                查看被邀请会员
                              </div>
                            </div>
                            <div class="visibility_active_view_box_expansion" v-if="ruleForm.treasureActivityInfo.visibilityType === 'SPECIFIED_USER'"></div>
                          </div>
                        </template>
                        <template #actions="{ confirm, cancel }">
                          <div class="flex_right">
                            <v-btn class="mg_r_2" size="small" @click="cancel">取消</v-btn>
                            <v-btn size="small" color="#796CB4" @click="confirm"
                            >确定</v-btn
                            >
                          </div>
                        </template>
                      </el-popconfirm>
                    </div>
                    <div v-else>
                      <div style="z-index: 10;position: relative">
                        <div :class="['flex_left', 'mg_r_3', 'cursor-pointer', {visibility_active : ruleForm.treasureActivityInfo.visibilityType === 'SPECIFIED_USER'}]">
                          <div class="flex_left" @click="handleVisibilityChange('SPECIFIED_USER')">
                            <div style="margin-right: 13px">
                              <YTRadio
                                  :show="ruleForm.treasureActivityInfo.visibilityType === 'SPECIFIED_USER'"
                              ></YTRadio>
                            </div>
                            <div style="font-size: 16px" class="tips">
                              仅被邀请会员可报名
                            </div>
                          </div>
                          <div @click="handleInviteMemberDialog" v-if="ruleForm.treasureActivityInfo.visibilityType === 'SPECIFIED_USER'" class="visibility_active_view_box cursor-pointer">
                            查看被邀请会员
                          </div>
                        </div>
                        <div class="visibility_active_view_box_expansion" v-if="ruleForm.treasureActivityInfo.visibilityType === 'SPECIFIED_USER'"></div>
                      </div>
                    </div>
                  </div>
                  <div class="flex_bt" v-else>
                    <div class="flex_left mg_r_3 cursor-pointer" @click="handleShowVisibilityError">
                      <div style="margin-right: 13px">
                        <YTRadio
                            :show="ruleForm.treasureActivityInfo.visibilityType === 'PUBLIC'"
                        ></YTRadio>
                      </div>
                      <div style="font-size: 16px" class="tips">
                        全平台公开
                      </div>
                    </div>
                    <div class="flex_left mg_r_3 cursor-pointer" @click="handleShowVisibilityError">
                      <div style="margin-right: 13px">
                        <YTRadio
                            :show="ruleForm.treasureActivityInfo.visibilityType === 'MEMBER_VISIBLE'"
                        ></YTRadio>
                      </div>
                      <div style="font-size: 16px" class="tips">
                        仅商家自身会员可报名
                      </div>
                    </div>
                    <div style="z-index: 10;position: relative">
                      <div :class="['flex_left', 'mg_r_3', 'cursor-pointer', {visibility_active : ruleForm.treasureActivityInfo.visibilityType === 'SPECIFIED_USER'}]">
                        <div class="flex_left" @click="handleVisibilityChange('SPECIFIED_USER')">
                          <div style="margin-right: 13px">
                            <YTRadio
                                :show="ruleForm.treasureActivityInfo.visibilityType === 'SPECIFIED_USER'"
                            ></YTRadio>
                          </div>
                          <div style="font-size: 16px" class="tips">
                            仅被邀请会员可见
                          </div>
                        </div>
                        <div @click="handleInviteMemberDialog" v-if="ruleForm.treasureActivityInfo.visibilityType === 'SPECIFIED_USER'" class="visibility_active_view_box cursor-pointer">
                          查看被邀请会员
                        </div>
                      </div>
                      <div class="visibility_active_view_box_expansion" v-if="ruleForm.treasureActivityInfo.visibilityType === 'SPECIFIED_USER'"></div>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="活动详情可见范围：" prop="visibilityType" style="margin-bottom: 20px" v-if="ruleForm.treasureActivityInfo.visibilityType === 'MEMBER_VISIBLE' || ruleForm.treasureActivityInfo.visibilityType === 'SPECIFIED_USER'">
                  <div class="flex_bt" v-if="!isEdit">
                    <div v-if="ruleForm.treasureActivityInfo.detailVisibilityType !== 'PUBLIC'">
                      <el-popconfirm
                          width="288"
                          @confirm="handleDetailVisibilityTypeChange('PUBLIC')"
                          :title="`确定报名范围设置为“全平台可见，${ruleForm.treasureActivityInfo.visibilityType === 'MEMBER_VISIBLE' ? '仅商家自身会员可报名' : '仅被邀请会员可报名'}”吗？活动发布后，将无法再次修改`"
                      >
                        <template #reference>
                          <div class="flex_left mg_r_3 cursor-pointer">
                            <div style="margin-right: 13px">
                              <YTRadio
                                  :show="ruleForm.treasureActivityInfo.detailVisibilityType === 'PUBLIC'"
                              ></YTRadio>
                            </div>
                            <div style="font-size: 16px" class="tips">
                              全平台公开
                            </div>
                          </div>
                        </template>
                        <template #actions="{ confirm, cancel }">
                          <div class="flex_right">
                            <v-btn class="mg_r_2" size="small" @click="cancel">取消</v-btn>
                            <v-btn size="small" color="#796CB4" @click="confirm"
                            >确定</v-btn
                            >
                          </div>
                        </template>
                      </el-popconfirm>
                    </div>
                    <div v-else>
                      <div class="flex_left mg_r_3 cursor-pointer">
                        <div style="margin-right: 13px">
                          <YTRadio
                              :show="ruleForm.treasureActivityInfo.detailVisibilityType === 'PUBLIC'"
                          ></YTRadio>
                        </div>
                        <div style="font-size: 16px" class="tips">
                          全平台公开
                        </div>
                      </div>
                    </div>
                    <div v-if="ruleForm.treasureActivityInfo.detailVisibilityType !== 'MEMBER_VISIBLE'">
                      <el-popconfirm
                          width="288"
                          @confirm="handleDetailVisibilityTypeChange('MEMBER_VISIBLE')"
                          :title="`报名范围设置为“仅商家自身会员可见${ruleForm.treasureActivityInfo.visibilityType === 'MEMBER_VISIBLE' ? '、可报名' : '，仅被邀请会员可报名'}”吗？活动发布后，将无法再次修改`"
                      >
                        <template #reference>
                          <div class="flex_left mg_r_3 cursor-pointer">
                            <div style="margin-right: 13px">
                              <YTRadio
                                  :show="ruleForm.treasureActivityInfo.detailVisibilityType === 'MEMBER_VISIBLE'"
                              ></YTRadio>
                            </div>
                            <div style="font-size: 16px" class="tips">
                              仅商家自身会员可见
                            </div>
                          </div>
                        </template>
                        <template #actions="{ confirm, cancel }">
                          <div class="flex_right">
                            <v-btn class="mg_r_2" size="small" @click="cancel">取消</v-btn>
                            <v-btn size="small" color="#796CB4" @click="confirm"
                            >确定</v-btn
                            >
                          </div>
                        </template>
                      </el-popconfirm>
                    </div>
                    <div v-else>
                      <div class="flex_left mg_r_3 cursor-pointer">
                        <div style="margin-right: 13px">
                          <YTRadio
                              :show="ruleForm.treasureActivityInfo.detailVisibilityType === 'MEMBER_VISIBLE'"
                          ></YTRadio>
                        </div>
                        <div style="font-size: 16px" class="tips">
                          仅商家自身会员可见
                        </div>
                      </div>
                    </div>
                    <div v-if="ruleForm.treasureActivityInfo.visibilityType === 'SPECIFIED_USER'">
                      <div v-if="ruleForm.treasureActivityInfo.detailVisibilityType !== 'SPECIFIED_USER'">
                        <el-popconfirm
                            width="288"
                            @confirm="handleDetailVisibilityTypeChange('SPECIFIED_USER')"
                            :title="`报名范围设置为“仅被邀请会员可见${ruleForm.treasureActivityInfo.visibilityType === 'MEMBER_VISIBLE' ? '，仅商家自身会员可见': '、可报名'}”吗？活动发布后，将无法再次修改`"
                        >
                          <template #reference>
                            <div class="flex_left mg_r_3 cursor-pointer">
                              <div style="margin-right: 13px">
                                <YTRadio
                                    :show="ruleForm.treasureActivityInfo.detailVisibilityType === 'SPECIFIED_USER'"
                                ></YTRadio>
                              </div>
                              <div style="font-size: 16px" class="tips">
                                仅被邀请会员可见
                              </div>
                            </div>
                          </template>
                          <template #actions="{ confirm, cancel }">
                            <div class="flex_right">
                              <v-btn class="mg_r_2" size="small" @click="cancel">取消</v-btn>
                              <v-btn size="small" color="#796CB4" @click="confirm"
                              >确定</v-btn
                              >
                            </div>
                          </template>
                        </el-popconfirm>
                      </div>
                      <div v-else>
                        <div class="flex_left mg_r_3 cursor-pointer">
                          <div style="margin-right: 13px">
                            <YTRadio
                                :show="ruleForm.treasureActivityInfo.detailVisibilityType === 'SPECIFIED_USER'"
                            ></YTRadio>
                          </div>
                          <div style="font-size: 16px" class="tips">
                            仅被邀请会员可见
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="flex_bt" v-else>
                    <div class="flex_left mg_r_3 cursor-pointer" @click="handleDetailVisibilityTypeChange('PUBLIC')">
                      <div style="margin-right: 13px">
                        <YTRadio
                            :show="ruleForm.treasureActivityInfo.detailVisibilityType === 'PUBLIC'"
                        ></YTRadio>
                      </div>
                      <div style="font-size: 16px" class="tips">
                        全平台公开
                      </div>
                    </div>
                    <div class="flex_left mg_r_3 cursor-pointer" @click="handleDetailVisibilityTypeChange('MEMBER_VISIBLE')">
                      <div style="margin-right: 13px">
                        <YTRadio
                            :show="ruleForm.treasureActivityInfo.detailVisibilityType === 'MEMBER_VISIBLE'"
                        ></YTRadio>
                      </div>
                      <div style="font-size: 16px" class="tips">
                        仅商家自身会员可见
                      </div>
                    </div>
                    <div v-if="ruleForm.treasureActivityInfo.visibilityType === 'SPECIFIED_USER'">
                      <div class="flex_left mg_r_3 cursor-pointer" @click="handleDetailVisibilityTypeChange('SPECIFIED_USER')">
                        <div style="margin-right: 13px">
                          <YTRadio
                              :show="ruleForm.treasureActivityInfo.detailVisibilityType === 'SPECIFIED_USER'"
                          ></YTRadio>
                        </div>
                        <div style="font-size: 16px" class="tips">
                          仅被邀请会员可见
                        </div>
                      </div>
                    </div>
                  </div>
                </el-form-item>
                <div class="flex_left tips" v-if="ruleForm.treasureActivityInfo.visibilityType === 'PUBLIC' || (ruleForm.treasureActivityInfo.visibilityType && ruleForm.treasureActivityInfo.detailVisibilityType)">
                  <img
                      style="width: 18px; height: 18px; margin-right: 10px;margin-left: 15px;"
                      src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/common/common/tips.svg"
                  />
                  <div v-if="ruleForm.treasureActivityInfo.visibilityType === 'PUBLIC'">
                    活动发布后，<span style="color: #684fa2">Biking Up 平台所有会员 </span> 均可见、报名参加
                  </div>
                  <div class="flex" v-if="ruleForm.treasureActivityInfo.visibilityType && ruleForm.treasureActivityInfo.detailVisibilityType">
                    活动发布后，
                    <div v-if="ruleForm.treasureActivityInfo.visibilityType === 'MEMBER_VISIBLE' && ruleForm.treasureActivityInfo.detailVisibilityType === 'PUBLIC'">
                      <span style="color: #684fa2">Biking Up 平台所有会员 </span>可见、<span style="color: #684fa2">仅商家自身会员 </span>可报名参加活动
                    </div>
                    <div v-if="ruleForm.treasureActivityInfo.visibilityType === 'MEMBER_VISIBLE' && ruleForm.treasureActivityInfo.detailVisibilityType === 'MEMBER_VISIBLE'">
                      <span style="color: #684fa2">仅商家自身会员 </span>均可见、可报名参加活动
                    </div>
                    <div v-if="ruleForm.treasureActivityInfo.visibilityType === 'SPECIFIED_USER' && ruleForm.treasureActivityInfo.detailVisibilityType === 'MEMBER_VISIBLE'">
                      <span style="color: #684fa2">仅商家自身会员 </span>可见、<span style="color: #684fa2">仅被邀请会员</span>可报名参加活动
                    </div>
                    <div v-if="ruleForm.treasureActivityInfo.visibilityType === 'SPECIFIED_USER' && ruleForm.treasureActivityInfo.detailVisibilityType === 'SPECIFIED_USER'">
                      <span style="color: #684fa2">仅被邀请会员 </span>均可见、可报名参加活动
                    </div>
                    <div v-if="ruleForm.treasureActivityInfo.visibilityType === 'SPECIFIED_USER' && ruleForm.treasureActivityInfo.detailVisibilityType === 'PUBLIC'">
                      <span style="color: #684fa2">Biking Up 平台所有会员 </span>可见，<span style="color: #684fa2">仅被邀请会员 </span>可报名参加活动
                    </div>
                  </div>
                </div>
                <el-form-item label="会员报名基础表单信息：" prop="memberBaseFormInfo" label-position="top" style="margin-bottom: 20px;">
                  <div class="checkbox_form_box">
                    <div class="checkbox_item">
                      <div>1. 联系人姓名：</div>
                      <div>
                        <el-checkbox-group class="checkbox_group_static" :model-value="ruleForm.treasureActivityInfo.emergencyContactRequirement" @change="(list) => handleRequirementSingleChange('emergencyContactRequirement', list, 'memberBaseFormInfo')">
                          <el-checkbox label="REQUIRED">需要，必填</el-checkbox>
                          <el-checkbox label="NOT_FILLED">不需要</el-checkbox>
                        </el-checkbox-group>
                      </div>
                    </div>
                    <div class="checkbox_item">
                      <div>2. 联系人电话：</div>
                      <div>
                        <el-checkbox-group class="checkbox_group_static" :model-value="ruleForm.treasureActivityInfo.emergencyContactPhoneRequirement" @change="(list) => handleRequirementSingleChange('emergencyContactPhoneRequirement', list, 'memberBaseFormInfo')">
                          <el-checkbox label="REQUIRED">需要，必填</el-checkbox>
                          <el-checkbox label="NOT_FILLED">不需要</el-checkbox>
                        </el-checkbox-group>
                      </div>
                    </div>
                    <div class="checkbox_item">
                      <div>3. 收货信息(收货地址和收件人)：</div>
                      <div>
                        <el-checkbox-group class="checkbox_group_static" :model-value="ruleForm.treasureActivityInfo.shippingInfoRequirement" @change="(list) => handleRequirementSingleChange('shippingInfoRequirement', list, 'memberBaseFormInfo')">
                          <el-checkbox label="REQUIRED">需要，必填</el-checkbox>
                          <el-checkbox label="OPTIONAL">需要，非必填</el-checkbox>
                          <el-checkbox label="NOT_FILLED">不需要</el-checkbox>
                        </el-checkbox-group>
                      </div>
                    </div>
                    <div class="checkbox_item">
                      <div>4. 备注信息：</div>
                      <div>
                        <el-checkbox-group class="checkbox_group_static" :model-value="ruleForm.treasureActivityInfo.remarkRequirement" @change="(list) => handleRequirementSingleChange('remarkRequirement', list, 'memberBaseFormInfo')">
                          <el-checkbox label="REQUIRED">需要，必填</el-checkbox>
                          <el-checkbox label="NOT_FILLED">不需要</el-checkbox>
                        </el-checkbox-group>
                      </div>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="游玩人报名详细表单信息：" prop="playerDetailFormInfo" label-position="top" style="margin-bottom: 20px;">
                  <div class="checkbox_form_box">
                    <div class="checkbox_item" style="display: block;">
                      <div class="flex" style="margin-bottom: 15px;">
                        <div>1. 证件信息(证件类型和证件号)：</div>
                        <div>
                          <el-checkbox-group class="checkbox_group_static" :model-value="ruleForm.treasureActivityInfo.certificateRequirement" @change="(list) => handleRequirementSingleChange('certificateRequirement', list, 'playerDetailFormInfo')">
                            <el-checkbox label="REQUIRED">需要，必填</el-checkbox>
                            <el-checkbox label="NOT_FILLED">不需要</el-checkbox>
                          </el-checkbox-group>
                        </div>
                      </div>
                      <div class="flex">
                        <div>&nbsp;&nbsp;&nbsp;&nbsp;证件信息类型可选范围(多选)：</div>
                        <div>
                          <el-select
                              :suffix-icon="$SelectArrowDown"
                              collapse-tags
                              multiple
                              :teleported="false"
                              v-model="ruleForm.treasureActivityInfo.certificateTypes"
                              :class="
                                ruleForm.treasureActivityInfo.certificateTypes.length === 0
                                  ? 'input-null'
                                  : 'input-filled'
                              "
                              style="width: 200px"
                              placeholder="可选证件类型"
                              @change="validateFieldSilently('playerDetailFormInfo')"
                          >
                            <el-option
                                v-for="item in certificateTypeOption"
                                :key="item?.stateId"
                                :label="item?.stateName"
                                :value="item?.stateId"
                            >
                              <template #default>
                                <div class="flex_bt">
                                  <div class="option-label">{{ item?.stateName }}</div>
                                  <img
                                      v-if="ruleForm.treasureActivityInfo.certificateTypes && ruleForm.treasureActivityInfo.certificateTypes.includes(item?.stateId)"
                                      style="width: 13px; height: 13px"
                                      src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/filter/filter/selected.svg"
                                  />
                                </div>
                              </template>
                            </el-option>
                          </el-select>
                        </div>
                      </div>
                    </div>
                    <div class="checkbox_item">
                      <div>2. 会员性别信息：</div>
                      <div>
                        <el-checkbox-group class="checkbox_group_static" :model-value="ruleForm.treasureActivityInfo.genderRequirement" @change="(list) => handleRequirementSingleChange('genderRequirement', list, 'playerDetailFormInfo')">
                          <el-checkbox label="REQUIRED">需要，必填</el-checkbox>
                          <el-checkbox label="NOT_FILLED">不需要</el-checkbox>
                        </el-checkbox-group>
                      </div>
                    </div>
                    <div class="checkbox_item">
                      <div>3. 会员出生日期：</div>
                      <div>
                        <el-checkbox-group class="checkbox_group_static" :model-value="ruleForm.treasureActivityInfo.birthdayRequirement" @change="(list) => handleRequirementSingleChange('birthdayRequirement', list, 'playerDetailFormInfo')">
                          <el-checkbox label="REQUIRED">需要，必填</el-checkbox>
                          <el-checkbox label="NOT_FILLED">不需要</el-checkbox>
                        </el-checkbox-group>
                      </div>
                    </div>
                  </div>
                </el-form-item>
              </template>
            </YTCard>
            <YTCard :isShowDivider="false" :title="`套餐商品`">
              <template #container>
                <div class="package_group_box">
                  <el-form-item label="套餐商品：" prop="groups" style="margin-bottom: 0">
                    <div class="flex_left">
                      <v-btn class="package_group_add_btn" variant="outlined" @click="handleAddPackageGroup">
                        <span style="font-size: 18px; margin-right: 10px;">+</span>
                        <span>添加分组</span>
                      </v-btn>
                    </div>
                  </el-form-item>
                  <div
                      class="package_group_item"
                      v-for="(item, index) in ruleForm.groups"
                      :key="`packageGroup${index}`"
                  >
                    <div class="package_group_input_row">
                      <div class="package_group_input_box">
                        <el-input
                            v-show="packageGroupNameTab[index] !== 'en'"
                            v-model="item.groupName"
                            maxlength="10"
                            show-word-limit
                            placeholder="请输入分组名称"
                            @blur="validateFieldSilently('groups')"
                        ></el-input>
                        <el-input
                            v-show="packageGroupNameTab[index] === 'en'"
                            v-model="item.groupNameEn"
                            maxlength="50"
                            show-word-limit
                            placeholder="Please enter group name"
                            @blur="validateFieldSilently('groups')"
                        ></el-input>
                      </div>
                      <YTI18NTabs v-model="packageGroupNameTab[index]"></YTI18NTabs>
                      <el-tooltip
                          class="box-item"
                          effect="dark"
                          content="删除"
                          placement="right">
                        <v-icon class="mg_l_2 cursor-pointer" color="error" icon="mdi-close" @click="handleRemovePackageGroup(index)"></v-icon>
                      </el-tooltip>
                    </div>
                    <div class="package_group_related_row" :style="item.items.length === 0 ? '': 'display: block'">
                      <div class="package_group_related_label">已关联商品：</div>
                      <div class="package_group_related_empty" v-if="item.items.length === 0">暂无关联商品信息</div>
                      <div v-else>
                        <div
                            class="package_group_related_item"
                            v-for="goods in item.items"
                            :key="goods.goodsId"
                        >
                          <div class="package_group_goods_name">{{ goods.goodsName }}</div>
                          <div>数量：</div>
                          <el-input-number
                              v-model="goods.fixedCount"
                              :min="1"
                              :precision="0"
                              style="width: 120px"
                          ></el-input-number>
                          <el-checkbox v-model="goods.depositRequired" label="需要押金"></el-checkbox>
                          <el-input-number
                              v-show="goods.depositRequired"
                              v-model="goods.depositAmount"
                              :min="0"
                              :precision="2"
                              :disabled="!goods.depositRequired"
                              style="width: 140px"
                              placeholder="押金"
                          ></el-input-number>
                          <el-tooltip
                              class="box-item"
                              effect="dark"
                              content="删除"
                              placement="right">
                            <v-icon class="mg_l_2 cursor-pointer" color="error" icon="mdi-close" @click="handleRemoveMerchandiseItem(goods.goodsId)"></v-icon>
                          </el-tooltip>
                        </div>
                      </div>
                    </div>
                    <div class="package_group_add_goods flex_left cursor-pointer" @click="handleOpenPackageGoodsList(index)">
                      <img
                          style="width: 25px; height: 25px; margin-right: 11px"
                          src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/createClub/add_member.svg"
                      />
                      <span>添加分组内商品</span>
                    </div>
                  </div>
                </div>
              </template>
            </YTCard>
            <YTCard :isShowDivider="false" :title="`第三方保险`">
              <template #container>
                <el-form-item prop="insurance" style="margin-bottom: 0">
                  <div class="insurance_box">
                    <div class="flex" style="column-gap: 30px;">
                      <div class="flex_left" style="cursor: not-allowed;">
                        <div style="margin-right: 13px;">
                          <YTRadio
                              :show="ruleForm.treasureActivityInfo.insurancePaymentType === 'PLATFORM_GIFT'"
                              :disabled="true"
                          ></YTRadio>
                        </div>
                        <div style="font-size: 16px" class="tips">
                          BIKING UP平台赠送
                        </div>
                      </div>
                      <div class="flex_left">
                        <div style="margin-right: 13px;">
                          <YTRadio
                              :show="ruleForm.treasureActivityInfo.insurancePaymentType === 'MEMBER_PAY'"
                          ></YTRadio>
                        </div>
                        <div style="font-size: 16px;" class="tips">
                          会员支付
                        </div>
                      </div>
                    </div>
                    <el-table
                        class="insurance_table"
                        :data="insuranceProductList"
                        v-loading="insuranceLoading"
                        border
                        :fit="false"
                        scrollbar-always-on
                        style="width: 100%; max-width: 100%; margin-top: 18px"
                        :header-cell-style="{ background: '#F5F6F7', color: '#272539', fontWeight: 600 }"
                    >
                      <el-table-column width="44" align="center">
                        <template #default="{ row }">
                          <el-checkbox
                              :model-value="isInsuranceProductChecked(row)"
                              @change="(checked) => handleInsuranceProductChange(row, checked)"
                          ></el-checkbox>
                        </template>
                      </el-table-column>
                      <el-table-column prop="insuranceName" label="保险产品名称" width="260" align="center"></el-table-column>
                      <el-table-column prop="insuranceProductCode" label="保险产品编号" width="170" align="center"></el-table-column>
                      <el-table-column prop="insuranceCompany" label="保险公司" width="280" align="center"></el-table-column>
                      <el-table-column label="保险保障期限" width="150" align="center">
                        <template #default="{ row }">
                          {{ handleInsuranceDuration(row) }}
                        </template>
                      </el-table-column>
                      <el-table-column label="保险价格" width="120" align="center">
                        <template #default="{ row }">
                          {{ handleInsurancePrice(row) }}
                        </template>
                      </el-table-column>
                      <template #empty>
                        <span>{{ insuranceTotal > 0 ? '暂无可选保险产品' : '没有更多数据了' }}</span>
                      </template>
                    </el-table>
                  </div>
                </el-form-item>
              </template>
            </YTCard>
            <YTCard :isShowDivider="false" :title="`费用`">
              <template #container>
                <div>
                  <el-form-item
                      label="活动时长："
                      prop="treasureActivityInfo.activityDuration"
                      style="margin-bottom: 20px; margin-top: 37px"
                  >
                    <el-input-number
                        :disabled="true"
                        :min="1"
                        :max="100000"
                        :precision="2"
                        v-model="ruleForm.treasureActivityInfo.activityDuration"
                        :class="
                          ruleForm.treasureActivityInfo.activityDuration === null ||
                          ruleForm.treasureActivityInfo.activityDuration === 0
                            ? 'input-null'
                            : 'input-filled'
                        "
                        style="width: 180px; height: 36px"
                        placeholder="请输入"
                    ></el-input-number>
                    <div
                        style="
                          font-weight: 500;
                          font-size: 18px;
                          color: #272539;
                          margin-left: 15px;
                        "
                    >
                      小时
                    </div>
                  </el-form-item>
                  <el-form-item
                      label="活动费用："
                      prop="retailPrice"
                      style="margin-bottom: 20px; margin-top: 37px"
                  >
                    <div class="father_box">
                      <el-input-number
                          class="coast_box"
                          :min="0"
                          :precision="2"
                          v-model="ruleForm.retailPrice"
                          :class="
                        ruleForm.retailPrice === null
                          ? 'input-null'
                          : 'input-filled'
                      "
                          style="width: 180px; height: 36px; text-align: left"
                          placeholder="活动费用"
                      >
                        <template #prefix>
                          <div
                              style="
                            width: 35px;
                            box-sizing: border-box;
                            padding-left: 20px;
                          "
                          >
                            ￥
                          </div>
                        </template>
                      </el-input-number>
                    </div>
                  </el-form-item>
                  <el-form-item
                      label="退费规则："
                      prop="refundSupported"
                      style="margin-bottom: 20px; margin-top: 37px"
                  >
                    <div class="flex">
                      <div class="flex_left">
                        <div style="margin-right: 13px">
                          <YTRadio
                              :show="ruleForm.treasureActivityInfo.refundSupported === true"
                          ></YTRadio>
                        </div>
                        <div style="font-size: 16px" class="tips">
                          订单未核销随时可退款
                        </div>
                      </div>
                    </div>
                  </el-form-item>
                </div>
              </template>
            </YTCard>
            <YTCard :isShowDivider="false" :title="`相册`" id="album">
              <template #container>
                <div>
                  <el-form-item label="活动相册" prop="album" style="margin-bottom: 20px">
                    <div class="flex_left mg_r_2">
                      <div style="margin-right: 13px">
                        <YTRadio
                            :show="ruleForm.treasureActivityInfo.hasAlbum && ruleForm.treasureActivityInfo.isSelfOss === false"
                            @click="handleSelectLiveAlbum"
                        ></YTRadio>
                      </div>
                      <div style="font-size: 16px" class="tips">创建直播相册</div>
                    </div>
                    <div class="flex_left">
                      <div style="margin-right: 13px">
                        <YTRadio
                            :show="ruleForm.treasureActivityInfo.hasAlbum && ruleForm.treasureActivityInfo.isSelfOss === true"
                            @click="handleSelectNonLiveAlbum"
                        ></YTRadio>
                      </div>
                      <div style="font-size: 16px" class="tips">创建非直播相册</div>
                    </div>
                    <el-input @blur="handleAlbumUrlBlur" class="mg_b_2" v-if="ruleForm.treasureActivityInfo.hasAlbum && ruleForm.treasureActivityInfo.isSelfOss === false" v-model="ruleForm.treasureActivityInfo.albumUrl" placeholder="请输入专属相册链接"></el-input>
                  </el-form-item>
                  <el-form-item label="">
                  </el-form-item>
                  <div class="flex_left tips flex_align_t">
                    <img
                        style="width: 18px; height: 18px; margin-right: 10px"
                        src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/common/common/tips.svg"
                    />
                    <div>
                      当您选择创建活动相册并发布活动后，将
                      <span style="color: #684fa2"
                      >增加活动相关的相册入口</span
                      >
                      ，会员报名后可查看相册。如下方示意图
                    </div>
                  </div>
                  <div
                      class="tips"
                      style="box-sizing: border-box; padding-left: 28px"
                  >
                    如您有任何疑问，请在周一至周五 10:00-17:00 致电 BIKING UP
                    服务热线咨询：400-8032-881
                  </div>
                  <div
                      class="tips"
                      style="
                      display: flex;
                      align-items: center;
                      margin-top: 20px;
                      padding-left: 28px;
                    "
                  >
                    <img
                        src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/club/album1.png"
                        style="
                        width: 278px;
                        height: 123px;
                      "
                    />
                    <img
                        src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/club/album2.png"
                        style="
                        width: 233px;
                        height: 123px;
                        margin-left: 30px;
                      "
                    />
                  </div>


<!--                  <div class="flex_left tips">-->
<!--                    <img-->
<!--                        style="width: 18px; height: 18px; margin-right: 10px"-->
<!--                        src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/common/common/tips.svg"-->
<!--                    />-->
<!--                    <div>-->
<!--                      活动费用由Biking Up 平台统一代收，平台将收取-->
<!--                      <span style="color: #684fa2">5%</span> 手续费-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div-->
<!--                      class="tips"-->
<!--                      style="box-sizing: border-box; padding-left: 28px"-->
<!--                  >-->
<!--                    最终结算金额Biking-->
<!--                    Up平台将在适用的结算周期内结算，具体信息请查看您签署的-->
<!--                    <span style="color: #684fa2">《俱乐部合作协议》</span>。-->
<!--                  </div>-->
                </div>
              </template>
            </YTCard>
          </div>
        </div>
        <div class="activity_form_bottom_box flex_right">
          <v-btn
              class="activity_form_bottom_btn"
              :color="`#4CAF50`"
              @click="handleSubmit"
          >立即发布</v-btn
          >
        </div>
      </div>
    </div>
  </el-form>
  <el-dialog
      id="dialog"
      v-model="open"
      width="990"
      style="padding: 20px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false">
    <template #header>
      <div class="flex_bt">
        <div class="yt_dialog_title" style="padding-bottom: 30px">报名范围(仅被邀请会员可见)</div>
        <img @click="handleDialogClose" v-if="isEdit" style="width: 24px;height: 24px;margin: 0 28px 0 0;cursor:pointer;" src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/common/common/dialog_close.svg"/>
      </div>
    </template>
    <div class="dialog_box">
      <div class="dialog_filter_box flex_bt">
        <div class="dialog_filter_topTriangle">
          <div class="dialog_filter_topTriangle_light"></div>
        </div>
        <div class="flex_left">
          <div class="dialog_filter_txt mg_r_1">
            {{isEdit ? "被邀请会员含标签:" : "指定范围:"}}
          </div>
          <div style="text-align: left">
            <YTTagSelect ref="YTTagSelectDialogRef" :limit="5" :selectedCount="dialogTagList.length" :width="416" :tagList="memberTagList" @tagChange="handleDialogTagChange">
              <template #trigger="{ toggle, visible }">
                <div v-if="!isEdit">
                  <div :class="['dialog_filter_select_box flex_align_t', dialogTagList.length === 0
                            ? 'input-null'
                            : 'input-filled'
                        ]">
                    <div class="flex_bt w-100">
                      <div style="flex:1;margin-right: 5px;">
                        <div class="dialog_filter_select_placeholder" v-if="dialogTagList.length === 0">请任选2-5个标签，匹配标签的所有会员将可见活动</div>
                        <div v-else class="flex flex_warp" style="gap: 5px;">
                          <div class="dialog_filter_select_tag flex_left" v-for="(item, index) in dialogTagList" :key="`tagListInput${index}`">
                            <div class="dialog_filter_select_tag_txt">{{item.tagName}}</div>
                            <div class="dialog_filter_select_tag_spaceLine"></div>
                            <div class="dialog_filter_select_tag_removeBtn" @click="handleRemoveDialogTag(item.tagId)">×</div>
                          </div>
                        </div>
                      </div>
                      <div class="dialog_filter_select_add_box flex_bt" @click="toggle" v-if="dialogTagList.length < 5">
                        <div>添加</div>
                        <img class="dialog_filter_select_add_icon" src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/activity/activity/dialog_tag_add.svg"/>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="flex flex_warp" style="gap: 5px;">
                    <div class="dialog_filter_select_tag flex_left" style="border-radius: 5px;" v-for="(item, index) in dialogTagList" :key="`tagListInput${index}`">
                      <div class="dialog_filter_select_tag_txt">{{item.tagName}}</div>
                    </div>
                  </div>
                </div>
              </template>
            </YTTagSelect>
          </div>
        </div>
        <div class="dialog_filter_checkedCount">
          已选{{dialogMemberTotal}}名会员
        </div>
      </div>
      <div class="dialog_table_box" v-loading="dialogLoading">
        <div v-if="dialogMemberList.length > 0">
          <el-table
              :data="dialogMemberList"
              :border="false"
              style="width: 100%;"
              :header-row-style="{color: '#272539'}"
              :row-style="{color: '#656565'}"
              v-loading="loading"
              stripe
          >
            <el-table-column prop="avatar" label="会员头像" align="center">
              <template #default="scope">
                <img style="width: 34px;height: 34px;border-radius: 34px;" :src="scope.row.avatar ? scope.row.avatar : 'https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/table/table/default_avatar.svg'">
              </template>
            </el-table-column>
            <el-table-column prop="nickname" label="会员昵称" width="150">
              <template #default="scope">
                <span>{{scope.row.nickname ? scope.row.nickname : "—"}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="gender" label="性别">
              <template #default="scope">
                <YTGender :gender="scope.row.gender"></YTGender>
              </template>
            </el-table-column>

            <el-table-column label="会员标签" width="250" show-overflow-tooltip :tooltip-formatter="formatTags">
              <template #default="scope">
                <div>
                  <div v-if="scope.row.tagList?.length > 0" style="text-wrap: nowrap">
                    <div>{{handleShowTagList(scope.row.tagList)}}</div>
                  </div>
                  <div v-else>—</div>
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="ftp" label="FTP">
              <template #default="scope">
                <span>{{scope.row.ftp ? scope.row.ftp + "W" : "—"}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="carBrand" label="车辆品牌">
              <template #default="scope">
                <span>{{scope.row.carBrand ? scope.row.carBrand : "—"}}</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="dialog_table_pagination_box">
            <div class="flex">
              <div :class="['dialog_table_pagination_btn', {dialog_table_pagination_btn_disabled: dialogPage <= 1}]" style="border-radius: 4px 0 0 4px;border-right: none;" @click="handleDialogPageBtnChange('reduction')">上一页</div>
              <div class="dialog_table_pagination_input_box">
                <input autocomplete="off" @input="handleDialogPageInput" @keydown.enter="handleDialogPageChange" @change="handleDialogPageChange" v-model="pageInput" name="left" class="dialog_table_pagination_input" style="text-align: right;padding-right: 2px;" />/
                <input :value="Math.ceil(dialogMemberTotal / dialogPageSize)" name="right" disabled class="dialog_table_pagination_input" style="text-align: left;padding-left: 2px" />
              </div>
              <div :class="['dialog_table_pagination_btn', {dialog_table_pagination_btn_disabled: dialogPage >= dialogMemberTotal / dialogPageSize}]" style="border-radius: 0 4px 4px 0;border-left: none;" @click="handleDialogPageBtnChange('plus')">下一页</div>
            </div>
          </div>
        </div>
        <div class="dialog_table_empty" v-else>
          <div v-show="dialogTagList.length === 0">暂无指定成员，请添加标签进行选择</div>
          <div v-show="dialogTagList.length > 0">选中的标签暂无成员，请先将成员添加标签或切换选择其他标签</div>
        </div>
      </div>
    </div>
    <template #footer>
      <div class="yt_dialog_footer">
        <v-btn v-if="!isEdit" color="#d7d7df" variant="elevated" @click="handleDialogClose">取消</v-btn>
        <v-btn v-if="!isEdit" class="mg_l_2" color="#4CAF50" variant="elevated" @click="handleDialogSubmit">确定</v-btn>
      </div>
    </template>
  </el-dialog>
  <el-dialog
      id="dialog"
      v-model="openExamples"
      width="600"
      style="padding: 20px"
      :title="'图片示例（用户浏览活动效果）'"
      :show-close="false">
    <div class="flex_center">
      <div class="mg_r_2">
        <img style="width: 200px;height: 400px;" src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/activity/activity/cover1_examples.png"/>
        <div style="text-align: center;font-size: 16px;">封面一所在位置</div>
      </div>
      <div>
        <img style="width: 200px;height: 400px;" src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/activity/activity/cover2_examples.png"/>
        <div style="text-align: center;font-size: 16px;">封面二所在位置</div>
      </div>
    </div>
  </el-dialog>
  <YTCheckPanel
      ref="packageGoodsPanelRef"
      v-if="openPackageGoodsList"
      :open="openPackageGoodsList"
      :title="`关联商品`"
      :list="packageGoodsList"
      :hasAll="false"
      :checkedLimit="1"
      :maxWidth="600"
      @cancel="handlePackageGoodsListClose"
      @confirm="handlePackageGoodsListConfirm"
      @select="handlePackageGoodsSelect"
  >
    <template #top>
      <div>
        <v-text-field
            :disabled="packageGoodsLoading"
            append-inner-icon="mdi-magnify"
            label="商品名称"
            placeholder="请输入商品名称"
            variant="outlined"
            v-model="cachePackageGoodsKeyword"
            @click:append-inner="handlePackageGoodsSearch"
            @keyup.enter.native="handlePackageGoodsSearch"
        ></v-text-field>
      </div>
    </template>
    <template v-slot:pagination>
      <div class="flex_right text-right pt-2" style="width: 100%;">
        <v-pagination
            v-model="packageGoodsPage"
            :length="Math.ceil(totalPackageGoods / packageGoodsPageSize)"
            :total-visible="6"
            @update:modelValue="handlePackageGoodsPageChange"
            v-if="totalPackageGoods > 0"
        ></v-pagination>
      </div>
    </template>
  </YTCheckPanel>
</template>

<style lang="scss" scoped>
.activity_upload_box {
  width: 377px;
  height: 100%;
  box-sizing: border-box;
  padding: 63px 0 0 53px;
  background-size: 100% 100%;
  border-radius: 15px 0 0 15px;
}
.activity_form_box {
  height: calc(100% - 120px);
  flex: 1;
  overflow-y: auto;
  margin-bottom: 35px;
  min-width: 0;
}
.activity_content_box,
.activity_form_inner {
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
}
.activity_form_bottom_box {
  box-sizing: border-box;
  padding: 0 40px 0 20px;
  .activity_form_bottom_btn {
    width: 150px;
    height: 50px;
    font-weight: 500;
    font-size: 19px;
    color: #ffffff;
  }
}

::v-deep(.el-form-item__label) {
  font-size: 18px;
}
::v-deep(.el-date-editor--datetime) {
  .el-input__wrapper {
    width: 280px;
    height: 36px;
    background: #ececf4;
    border-radius: 15px;
  }
}
::v-deep(.el-form-item) {
  margin-bottom: 37px;
}
::v-deep(.el-form-item__label) {
  display: inline-block;
  height: 44px;
  line-height: 44px;
}
::v-deep(.coast_box .el-input__inner) {
  text-align: left;
}
::v-deep(.cycling_box .el-input__inner) {
  text-align: right;
}
.tips {
  font-weight: 500;
  font-size: 14px;
  color: #6f717d;
}

.yt_tag_select_box {
  min-width: 240px;
  height: 36px;
  .yt_tag_select_suffix {
    .yt_tag_select_suffix_icon {
      transition: transform 0.2s ease;
    }
    .reverse {
      transform: rotate(180deg);
    }

  }
  .yt_tag_select_placeholder {
    color: #a8abb2;
  }
  .yt_tag_select_tag {
    width: 108px;
    background: #F4F4F5;
    border-radius: 6px;
    box-sizing: border-box;
    padding: 4px 10px;
    font-weight: 400;
    font-size: 13px;
    color: #989BA1;
    margin-right: 5px;
  }
  .yt_tag_select_tag:last-child {
    margin-right: 0;
  }
}

.visibility_active {
  background: #F1EFF9;
  border-radius: 15px;
  border: 1px solid #7A6DB4;
  box-sizing: border-box;
  padding: 6px 8px;
  position: relative;
  z-index: 9;
}
.visibility_active_view_box {
  position: absolute;
  top: 0;
  right: 0;
  height: 25px;
  line-height: 25px;
  background: #7A6DB4;
  border-radius: 9px;
  transform: translate(0%, -25px);
  font-weight: 400;
  font-size: 13px;
  color: #FFFFFF;
  box-sizing: border-box;
  padding: 1px 10px;
  user-select: none;
}
.visibility_active_view_box_expansion {
  position: absolute;
  top: -5px;
  right: 31px;
  width: 50px;
  height: 25px;
  background: #7A6DB4;
  z-index: 8;
}
.insurance_box {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
}
::v-deep(.insurance_table) {
  max-width: 100%;
}
::v-deep(.insurance_table .el-table__cell) {
  padding: 6px 0;
}
::v-deep(.insurance_table .cell) {
  line-height: 22px;
}
.package_group_box {
  width: 100%;
}
.package_group_add_btn {
  min-width: 120px;
  height: 42px;
  color: #272539;
}
.package_group_item {
  width: 100%;
  box-sizing: border-box;
  padding-left: 95px;
  margin-top: 20px;
}
.package_group_input_row {
  display: flex;
  align-items: center;
  gap: 12px;
}
.package_group_input_box {
  width: 260px;
}
.package_group_related_row {
  display: flex;
  align-items: center;
  margin: 24px 0 18px 16px;
  font-size: 16px;
  color: #6f717d;
}
.package_group_related_label {
  font-weight: 400;
  color: #272539;
}
.package_group_related_empty {
  margin-left: 15px;
  font-weight: 400;
}
.package_group_related_item {
  margin-left: 28px;
  font-weight: 500;
  color: #272539;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 10px;
}
.package_group_goods_name {
  min-width: 100px;
}
.package_group_add_goods {
  margin-left: 16px;
  font-weight: 400;
  font-size: 14px;
  color: #6f717d;
}
.dialog_box {
  box-sizing: border-box;
  padding: 0 33px;
  .dialog_filter_box {
    width: 100%;
    min-height: 64px;
    background: #F5F6F7;
    border-radius: 15px 15px 0 0;
    border: 1px solid #DADDE2;
    box-sizing: border-box;
    padding: 8px 35px;
    position: relative;
    .dialog_filter_topTriangle {
      width: 14px;
      height: 7px;
      background: #DADDE2;
      clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
      position: absolute;
      top: -7px;
      left: 40px;
      .dialog_filter_topTriangle_light {
        width: 12px;
        height: 6px;
        background: #F5F6F7;
        clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
        position: absolute;
        bottom: -0.3px;
        left: 1px;
      }
    }
    .dialog_filter_txt {
      font-weight: 500;
      font-size: 18px;
      color: #6F717D;
    }
    .dialog_filter_checkedCount {
      font-weight: 500;
      font-size: 16px;
      color: #18263C;
    }
    .dialog_filter_select_box {
      width: 465px;
      min-height: 42px;
      background: #FFFFFF;
      border-radius: 21px;
      border: 1px solid #DADDE2;
      box-sizing: border-box;
      padding: 11px 7px 11px 17px;
      .dialog_filter_select_placeholder {
        font-weight: 400;
        font-size: 16px;
        color: #9C9EAB;
        user-select: none;
      }
      .dialog_filter_select_add_box {
        width: 104px;
        height: 30px;
        background: #ECECF4;
        border-radius: 15px;
        box-sizing: border-box;
        padding: 0 24px;
        font-weight: 400;
        font-size: 16px;
        color: #6F717D;
        cursor: pointer;
      }
      .dialog_filter_select_add_icon {
        width: 17px;
        height: 17px;
      }
    }
    .dialog_filter_select_box:hover {
      box-shadow: 0 0 0 1px #272539;
    }
    .dialog_filter_select_tag {
      height: 25px;
      background: #F1EBFF;
      border-radius: 15px;
      border: 1px solid #DECEFF;
      box-sizing: border-box;
      padding: 5px 7px;
      color: #B292F1;
      .dialog_filter_select_tag_txt {
        font-weight: 500;
        font-size: 11px;
        line-height: 20px;
        text-wrap: nowrap;
      }
      .dialog_filter_select_tag_spaceLine {
        width: 1px;
        height: 13px;
        background-color: #B292F1;
        margin: 0 3px;
      }
      .dialog_filter_select_tag_removeBtn {
        font-size: 16px;
        cursor: pointer;
      }
    }
    .dialog_filter_select_tag:last-child {
      margin-right: 0;
    }
  }
  .dialog_table_box {
    width: 100%;
    min-height: 515px;
    background: #FFFFFF;
    border-radius: 0 0 15px 15px;
    border: 1px solid #DADDE2;
    border-top: none;
    position: relative;
    padding-bottom: 64px;
    .dialog_table_empty {
      width: 100%;
      height: 515px;
      font-weight: 500;
      font-size: 22px;
      color: #BBBABA;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    ::v-deep(.el-table__header-wrapper) {
      display: none;
    }
    .dialog_table_pagination_box {
      width: 100%;
      height: 64px;
      background: #F5F6F7;
      border-radius: 0 0 15px 15px;
      position: absolute;
      bottom: 0;
      left: 0;
      box-sizing: border-box;
      padding: 0 36px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .dialog_table_pagination_btn {
        background: #FFFFFF;
        border: 1px solid #DADDE2;
        box-sizing: border-box;
        padding: 0 10px;
        font-weight: 400;
        font-size: 14px;
        color: #828D98;
        line-height: 29px;
        cursor: pointer;
        user-select: none;
      }
      .dialog_table_pagination_btn_disabled {
        cursor: not-allowed!important;
        color: #9C9EAB!important;
      }
      .dialog_table_pagination_input_box {
        min-width: 92px;
        height: 31px;
        background: #FFFFFF;
        border: 1px solid #DADDE2;
        font-weight: 500;
        font-size: 14px;
        color: #828D98;
        .dialog_table_pagination_input {
          width: 65px;
          padding: 0 10px;
          line-height: 30px;
          font-weight: 500;
          font-size: 14px;
          color: #828D98;
          outline: none;
        }
        .dialog_table_pagination_input:focus {
          color: #000!important;
        }
      }
    }
  }
}
.add_btn_txt {
  color: #684FA2;
  font-size: 14px;
}
.add_btn_txt_tips {
  color: #6F717D;
  font-size: 14px;
}
.groups_info {
  width: 100%;
  font-family: OPPOSans;
  font-weight: 500;
  .groups_info_title {
    color: #272539;
    font-size: 18px;
  }
  .groups_input {
    height: 44px;
    background: #FFFFFF;
    font-size: 16px;
    color: #000000;
    ::v-deep(.el-input__wrapper) {
      height: 44px;
      box-sizing: border-box;
      border-radius: 0;
    }
  }
  ::v-deep(.el-input-number) {
    border-radius: 0;
    .el-input__wrapper {
      height: 44px;
      border-radius: 0;
      font-size: 16px;

      font-weight: 500;
      color: #000000;
    }
    .el-input-number__decrease,.el-input-number__increase {
      border-radius: 0;
      width: 40px;
      height: 42px;
    }
    .el-input__inner {
      text-align: left;
    }
  }
  .groups_info_suffix {
    ::v-deep(.el-input-number) {
      .el-input__inner {
        text-align: right;
      }
    }
  }
}
.checkbox_item {
  box-sizing: border-box;
  padding-bottom: 15px;
  border-bottom: 1px solid #c5c7cb;
  color: #6f717d;
  display: grid;
  grid-template-columns: 200px 1fr;
  align-items: center;
  margin-bottom: 15px;
}
.checkbox_form_box {
  width: 100%;
}
.checkbox_group_static {
  display: flex;
  align-items: center;
  gap: 42px;
}
::v-deep(.el-checkbox__input.is-checked .el-checkbox__inner),
::v-deep(.el-checkbox__input.is-indeterminate .el-checkbox__inner) {
  background-color: #7970af;
  border-color: #7970af;
}
::v-deep(.el-checkbox__input.is-checked + .el-checkbox__label) {
  color: #606266;
}
::v-deep(.el-checkbox__input.is-focus .el-checkbox__inner),
::v-deep(.el-checkbox__inner:hover) {
  border-color: #7970af;
}
::v-deep(.is-selected::after) {
  display: none;
}
::v-deep(.is-selected) {
  color: #796cb4;
}
</style>
